/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/models/meevo.dtos.d.ts" />

module Meevo.Plugins.TransactionEditor {
    "use strict";

    enum PrintTypeEnum {
        Receipt,
        GiftReceipt,
        InsuranceReceipt,
        MerchantCreditCardReceipt,
        MerchantCreditCardVoidReceipt,
        HoldReceipt
    }

    interface FilterItemType {
        displayName: string,
        itemType: Model.SalesTypeEnum,
        template: string
    }

    export class TransactionEditorContext {
        get $translate() { return this.transactionEditorController.$translate; }
        get $mdDialog() { return this.transactionEditorController.$mdDialog; }
        get $q() { return this.transactionEditorController.$q; }
        get $scope() { return this.transactionEditorController.$scope; }
        get $rootScope() { return this.transactionEditorController.$rootScope; }
        get $timeout() { return this.transactionEditorController.$timeout; }
        get $cookies() { return this.transactionEditorController.$cookies; }

        get appSettings() { return this.transactionEditorController.appSettings; }
        get dataService() { return this.transactionEditorController.dataService; }
        get modalService() { return this.transactionEditorController.modalService; }
        get identityService() { return this.transactionEditorController.identityService; }
        get securityService() { return this.transactionEditorController.securityService; }
        get printService() { return this.transactionEditorController.printService; }
        get busyService() { return this.transactionEditorController.busyService; }
        get roundingService() { return this.transactionEditorController.roundingService; }
        get trackingService() { return this.transactionEditorController.trackingService; }
        get loggingService() { return this.transactionEditorController.loggingService; }
        get reportRouterService() { return this.transactionEditorController.reportRouterService; }
        get meevoDateFilter() { return this.transactionEditorController.meevoDateFilter; }
        get registerDiscountService() { return this.transactionEditorController.registerDiscountService; }
        get $compile() { return this.transactionEditorController.$compile; }
        get tippyService() { return this.transactionEditorController.tippyService; }

        public criteria: any;
        public allDrawers: any[] = [];
        public allPaymentTypes: Model.PaymentTypeListItem[] = [];
        public isEditing: boolean = false;
        public isEditingPermanentlyEditableFields: boolean = false;
        public transactionResults: any = { items: null };
        public sale: any;
        public canEdit: boolean = false;
        public canHold: boolean = false;
        public canRefund: boolean = false;
        public creditCardProcessingEnabled: boolean = false;
        protected modifiedPaymentLines: Model.SalePayment[] = [];
        public client: Meevo.Model.ClientListItem;
        public clients: Meevo.Model.ClientListItem[];
        public employee: Meevo.Model.EmployeeListItem;
        public teacher: Meevo.Model.EmployeeListItem;
        public employees: Meevo.Model.EmployeeListItem[];
        public drawer: Meevo.Model.Drawer;
        public paymentType: Model.PaymentTypeListItem;
        public user: Meevo.Model.EmployeeListItem;
        public receiptPreference: Model.RegisterReceiptTypeEnum = 0;
        public showGiftReceiptPrintOption: boolean = false;
        public selectedDrawer: Meevo.Model.Drawer;
        public canRefundTransactionFlags: any[] = [];
        public isEmailEnabled: boolean = true;
        public defaultTipType: Model.TipAmountTypeEnum;
        public percentageTipValues: number[] = null;
        public amountTipValues: number[] = null;
        public merchantCanVoidHash: {} = {};
        public drawerCanVoidHash: {} = {};
        public isFilterHidden: boolean = false;
        public canViewStudentTeacherModule: boolean = false;
        public securityGiftCardLookup: Model.SecurityAccessEnum;
        private showSaveMessage: boolean = false;
        editShopSuppliesSecurity: Model.SecurityItem;
        editProductSecurity: Model.SecurityItem;
        voidTransactionSecurity: Model.SecurityItem;

        public editClientSecurityKey: string;
        public editPaymentMethodSecurityKey: string;
        public editServiceSecurityKey: string;
        public editNoteSecurityKey: string;

        public isSurchargeModuleEnabled: boolean;

        public filterItemTypes: FilterItemType[] = [
            { displayName: 'LABEL_SERVICE', itemType: this.salesTypeEnum.Service, template: 'service' },
            { displayName: 'LABEL_PRODUCT', itemType: this.salesTypeEnum.Product, template: 'productvariant' }
        ];
        public filterItemCriteria = {
            includeActive: true,
            includeInactive: true,
            IncludeDeleted: true
        }
        public selectedFilterItemType: FilterItemType;
        public selectedFilterItem: any;

        public HouseEmployee: Model.EmployeeListItem = {
            id: Guid.empty.toString(),
            displayName: "HOUSE: House",
            lastName: "House",
            firstName: "House",
            code: "HOUSE",
            isEmployee: false,
            allowSales: true,
            allowTips: true
        };

        public UnassignedTeacher: Model.EmployeeListItem = {
            id: Guid.empty.toString(),
            displayName: ""
        };

        private merchantAccountIdByDrawerId = new Map<string, string>();
        private surchargePaymentTypesByMerchantAccountId = new Map<string, Model.MerchantAccountSurcharge[]>();

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        approvalCodePattern = /^[a-zA-Z0-9]*$/;
        showInsertTransaction = false;

        constructor(public transactionEditorController: Meevo.Plugins.TransactionEditor.TransactionEditorController,
            protected params: any
        ) {

            this.getAllDrawers();
            this.getSecurityValues();
            this.getAllPaymentTypes();
            this.getDefaultCriteria();
            this.getBusinessInfo();

            this.UnassignedTeacher.displayName = this.$translate.instant("LABEL_NO_TEACHER_SELECTED");

            this.securityService.checkSecurityKey(this.meevoSecurityKeys.DATA_STUDENTTEACHERMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.canViewStudentTeacherModule = result === Meevo.Model.SecurityAccessEnum.Grant;
            });

            this.securityService.checkSecurityKey(this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDLOOKUP + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.securityGiftCardLookup = result;
            });

            this.securityService.checkSecurityItem(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_PRODUCTWRITE).then(securityItem => {
                this.editProductSecurity = securityItem;
            });

            this.securityService.checkSecurityItem(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_PRODUCTWRITE_EDITSHOPSUPPLIES + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(securityItem => {
                this.editShopSuppliesSecurity = securityItem;
            });

            this.securityService.checkSecurityItem(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_VOIDTRANSACTION).then(securityItem => {
                this.voidTransactionSecurity = securityItem;
            });

            this.securityService.checkModuleAccess(this.meevoSecurityKeys.REGISTER_MERCHANTACCOUNT_TAB_SURCHARGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(accessEnum => {
                this.isSurchargeModuleEnabled = accessEnum === Model.SecurityAccessEnum.Grant;
            });

            this.updateFieldEditSecurityKey(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_CLIENTWRITE).then(key => this.editClientSecurityKey = key);
            this.updateFieldEditSecurityKey(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_PAYMENTMETHODWRITE).then(key => this.editPaymentMethodSecurityKey = key);
            this.updateFieldEditSecurityKey(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_SERVICEWRITE).then(key => this.editServiceSecurityKey = key);
            this.updateFieldEditSecurityKey(this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION_NOTEWRITE).then(key => this.editNoteSecurityKey = key);

            // If on mobile and transactionId is included upon load, show result view as default instead of filter view
            if (device.mobile() && this.criteria.transactionId) {
                this.isFilterHidden = true;
            }

            this.transactionEditorController.transactionEditorService.getDaysToEditTransaction().then((daysToEdit) => {
                this.showInsertTransaction = daysToEdit > 0;
            });
        }

        productInventoryTypeExclusionList = [Model.ProductInventoryTypeEnum.Other, Model.ProductInventoryTypeEnum.RetailOrShopSupply];

        // Virtual method to interact with paging functionality
        forcePageLoading(criteria: any): void { };

        getDefaultCriteria() {
            // Use pre-loaded params when available on initialization
            this.criteria = {
                transactionId: null,
                startDateTime: moment().startOf("day").toDate(),
                endDateTime: moment().endOf("day").toDate(),
                clientIds: [],
                employeeId: null,
                drawerId: null,
                paymentTypeId: null,
                createdById: null,
                includeCompleted: true,
                includeRefunded: true,
                includeVoided: true,
                includeOnHold: false,
                archivedOnHold: false,
                isEdited: false,
                isDeclinedRefundTransaction: false,
                requiredItemId: null,
                requiredSalesType: null,
                ...this.params
            };
            this.client = null;
            this.clients = [];
            this.employee = null;
            this.employees = [];
            this.drawer = null;
            this.user = null;
            this.selectedFilterItem = this.selectedFilterItemType = null;

            return this.criteria;
        }

        getSecurityValues() {

            let keysToCheck: string[] = [
                this.meevoSecurityKeys.REGISTER_REGISTER_SALEHOLD_ACTION_ADD,
                this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION
            ];
            this.securityService.checkAndCache(keysToCheck).then((response) => {
                let securityItem: any = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_SALEHOLD_ACTION_ADD });
                if (securityItem) {
                    this.canHold = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                this.canRefund = true; // ???
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR_ACTION_EDITTRANSACTION });
                if (securityItem) {
                    this.canEdit = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
            });
        }

        getAllPaymentTypes() {
            let request = {
                criteria: {
                    includeNonMonetary: null,
                    includeActive: true,
                    includeDeleted: true,
                    includeInactive: true
                },
                pageNumber: 0,
                itemsPerPage: 1000
            };
            this.dataService.customMethodData("api/paymentType/list", "POST", request).then((response) => {
                this.allPaymentTypes = response.data;
            });
        }

        getPaymentTypeList(paymentLine: Model.SalePayment): Model.PaymentTypeListItem[] {
            const filtered = [];

            if (!this.isImmutablePaymentCat(paymentLine.paymentCategory) && !this.isCCPaymentCat(paymentLine.paymentCategory, paymentLine.paymentRequestId)) {
                this.allPaymentTypes
                    .filter(paymentType => paymentType.objectState === Meevo.Model.ObjectStateEnum.Active)
                    .forEach((paymentType) => {
                        if (!this.isImmutablePaymentCat(paymentType.paymentCategory) && !this.isCCPaymentCat(paymentType.paymentCategory)) {
                            filtered.push(paymentType);
                        }
                    });
            }

            return filtered;
        };

        private static _immutablePaymentCategory = [
            Meevo.Model.PaymentCategoryEnum.GiftCard,
            Meevo.Model.PaymentCategoryEnum.PointsRewards,
            Meevo.Model.PaymentCategoryEnum.ACH,
            Meevo.Model.PaymentCategoryEnum.TRANSFER,
            Meevo.Model.PaymentCategoryEnum.ClientAccount,
            Meevo.Model.PaymentCategoryEnum.CareCredit,
            Meevo.Model.PaymentCategoryEnum.PaymentPlan,
            Meevo.Model.PaymentCategoryEnum.DeferredVoid,
            Meevo.Model.PaymentCategoryEnum.CashRounding,
        ];

        private isImmutablePaymentCat(paymentCategory: Meevo.Model.PaymentCategoryEnum): boolean {
            return TransactionEditorContext._immutablePaymentCategory.indexOf(paymentCategory) !== -1;
        }

        private isCCPaymentCat(paymentCategory: Meevo.Model.PaymentCategoryEnum, paymentRequestId?: string): boolean {
            const paymentCategoryCredit = [
                Meevo.Model.PaymentCategoryEnum.CreditDebit,
            ];

            if (paymentCategoryCredit.indexOf(paymentCategory) > -1
                && !this.creditCardProcessingEnabled
                && !paymentRequestId) {
                return false;
            }

            return paymentCategoryCredit.indexOf(paymentCategory) > -1
                && (!!paymentRequestId || this.creditCardProcessingEnabled);
        }

        private paymentRequestDeferredUpdate(paymentLine: Meevo.Model.SalePayment) {
            const url = `api/paymentRequest/${paymentLine.paymentRequestId}/deferredUpdate`;
            return this.dataService.customMethodData(url, "POST", null);
        }

        isPaymentLineDeferred(paymentLine: Meevo.Model.SaleCreditCardPayment) {
            if (!paymentLine) {
                return false;
            }

            return paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit &&
                   paymentLine.paymentRequest &&
                   paymentLine.paymentRequest.processorResponseCode === Model.ProcessorResponseCodeEnum.Queued;
        }

        isDeferredVoidVisible(transItem): boolean {
            if (!transItem) {
                return false;
            }

            const sale = transItem.detail;

            if (!sale) {
                return false;
            }

            return _(sale.saleLines).all(saleLine => saleLine.client.clientType !== Meevo.Model.ClientTypeEnum.Client);
        }

        isDeferredVoid(paymentLine: Meevo.Model.SaleCreditCardPayment) {
            return paymentLine.paymentCategory === Model.PaymentCategoryEnum.DeferredVoid;
        }

        isPaymentLineDeclined(paymentLine: Meevo.Model.SaleCreditCardPayment) {
            if (!paymentLine ||
                paymentLine.paymentCategory !== Model.PaymentCategoryEnum.CreditDebit ||
                !paymentLine.paymentRequest) {
                return false;
            }

            const salePaymentDeferredVoidKey = paymentLine as Model.SalePaymentDeferredVoidKey;
            if (salePaymentDeferredVoidKey.deferredVoidKey) {
                return false;
            }

            if (this.isDeferredVoid(paymentLine)) {
                return false;
            }

            if (paymentLine.paymentRequest.processorResponseCode === Model.ProcessorResponseCodeEnum.Queued) {
                return false;
            }

            return paymentLine.paymentRequest.processorResponseCode !== Model.ProcessorResponseCodeEnum.Success &&
                   paymentLine.paymentRequest.paymentRequestStatus !== Model.PaymentRequestStatusEnum.Approved;
        }

        private populatePaymentLines(transItem) {
            transItem.displayMerchantReceipt = false;
            transItem.displayMerchantVoidReceipt = false;
            for (const paymentLine of transItem.detail.paymentLines) {
                paymentLine.paymentType = _.findWhere(this.allPaymentTypes, { id: paymentLine.paymentTypeId });
                paymentLine.paymentTypeList = this.getPaymentTypeList(paymentLine);

                const isValidCreditDebit = paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit &&
                    (paymentLine as Model.SaleCreditCardPayment).paymentRequestId;

                this.cacheDeferredVoidLink(paymentLine, transItem.detail.deferredVoidLinks);

                if (isValidCreditDebit &&
                    !paymentLine.deferredVoidKey &&
                    this.isPaymentLineDeferred(paymentLine) &&
                    !paymentLine.isDeferred
                ) {
                    paymentLine.isDeferred = true;
                    console.debug('deferred update start');
                    this.paymentRequestDeferredUpdate(paymentLine).then((response) => {
                        console.debug('deferred update complete');
                        if (response.status === 409) {
                            return;
                        }

                        const paymentRequest = response.data;
                        console.debug('deferred update result', paymentLine.paymentRequest, paymentRequest);
                        if (!paymentRequest) {
                            return;
                        }

                        paymentLine.paymentRequest = paymentRequest;
                        if (paymentRequest.paymentRequestStatus !== Model.PaymentRequestStatusEnum.Approved) {
                            paymentLine.isDeferred = false;
                        }
                    });
                }

                transItem.displayMerchantReceipt = transItem.displayMerchantReceipt ||
                    (isValidCreditDebit && transItem.saleState === Model.SaleStateEnum.Completed);
                transItem.displayMerchantVoidReceipt = transItem.displayMerchantVoidReceipt ||
                    (isValidCreditDebit && transItem.saleState === Model.SaleStateEnum.Void);
            }
        }

        getBusinessInfo() {
            this.dataService.customMethodData("api/Tenant/BusinessInfo/Settings", "get", {}).then((data) => {
                let registerSettings: Model.RegisterSettings = data.data.registerSettings;
                this.creditCardProcessingEnabled = registerSettings.enableCreditCardProcessing;

                this.defaultTipType = data.data.registerSettings.defaultTipType;

                if (Model.Guard.isSomething(data.data.registerSettings.percentageTipValues)) {
                    this.percentageTipValues = angular.fromJson(data.data.registerSettings.percentageTipValues);
                }

                if (Model.Guard.isSomething(data.data.registerSettings.amountTipValues)) {
                    this.amountTipValues = angular.fromJson(data.data.registerSettings.amountTipValues);
                }
            });
        }

        preApplyFilter() {
            if (!this.criteria.includeCompleted && !this.criteria.includeRefunded && !this.criteria.includeVoided && !this.criteria.includeOnHold && !this.criteria.isEdited) {
                this.modalService.alert("MESSAGE_SELECT_ONE_TRANSACTION_STATUS", Components.Modal.ModalTranslationModes.Translate);
                return false;
            }
            this.isEditing = false;
            this.isEditingPermanentlyEditableFields = false;

            return true;
        }

        getAllDrawers(): any {
            let requestObj = { criteria: { useUserId: true } };
            return this.dataService.customMethodData("api/drawer/list/", "POST", requestObj).then((response) => {
                this.allDrawers = response.data;
                return this.allDrawers;
            });
        }

        getTransactionDetail(transItem) {
            let id = transItem.transactionId;
            let guid = transItem.transactionGuid;

            if (id.substr(0, 4) == "HOLD") {
                return this.dataService.customMethodData(`api/saleHold/${guid}`, "GET", null, { includeArchived: true }).then((response) => {
                    transItem.detail = response.data;
                    this.populatePaymentLines(transItem);
                    transItem.detail.saleLines.forEach((item) => {
                        this.employeeChanged(item);
                        if (!item.finalPrice) {
                            item.finalPrice = (item.finalItemPrice * item.quantity);
                        }
                    });
                    transItem.detailCopy = angular.copy(transItem.detail);
                });
            }
            else {
                const params = {
                    locale: this.appSettings.APP_COUNTRYID
                };
                return this.dataService.customMethodData(`api/sale/${id}`, "GET", null, params).then((response) => {
                    transItem.detail = response.data;
                    this.loadSale(transItem);
                    transItem.detailCopy = angular.copy(transItem.detail);
                });
            }
        }

        setProductSecurity(saleLine: Model.TransactionEditorSaleLine) {
            saleLine.productSecurity = { isDisabled: false, canElevate: false };
            saleLine.inventoryTypeSecurity = { isDisabled: false, canElevate: false };

            if (saleLine.item.productInventoryType === Model.ProductInventoryTypeEnum.Retail) {
                if (this.editProductSecurity.securityAccess === Model.SecurityAccessEnum.Hide) {
                    saleLine.productSecurity.isDisabled = true;
                }
                else if (this.editProductSecurity.securityAccess === Model.SecurityAccessEnum.Deny) {
                    saleLine.productSecurity.isDisabled = true;
                    saleLine.productSecurity.canElevate = true;
                }
            }
            else if (saleLine.item.productInventoryType === Model.ProductInventoryTypeEnum.ShopSupply) {
                if (this.editShopSuppliesSecurity.securityAccess === Model.SecurityAccessEnum.Hide) {
                    saleLine.productSecurity.isDisabled = true;
                }
                else if (this.editShopSuppliesSecurity.securityAccess === Model.SecurityAccessEnum.Deny) {
                    saleLine.productSecurity.isDisabled = true;
                    saleLine.productSecurity.canElevate = true;
                }
            }

            if (this.editShopSuppliesSecurity.securityAccess === Model.SecurityAccessEnum.Hide) {
                saleLine.inventoryTypeSecurity.isDisabled = true;
            }
            else if (this.editShopSuppliesSecurity.securityAccess === Model.SecurityAccessEnum.Deny) {
                saleLine.inventoryTypeSecurity.isDisabled = true;
                saleLine.inventoryTypeSecurity.canElevate = true;
            }
        }

        isInventoryTypeDisabled(saleLine) {
            return !this.saleLineItemEditable(saleLine) || saleLine.inventoryTypeSecurity.isDisabled;
        }

        checkSecurity(isProductControl, saleLine) {
            if (!this.saleLineItemEditable(saleLine) ||
                (isProductControl && (!saleLine.productSecurity.isDisabled || !saleLine.productSecurity.canElevate)) ||
                (!isProductControl && (!saleLine.inventoryTypeSecurity.isDisabled || !saleLine.inventoryTypeSecurity.canElevate))) {
                return;
            }

            let securityItem = isProductControl ? this.editProductSecurity : this.editShopSuppliesSecurity;
            let defer = this.$q.defer();
            defer.promise.then(() => {
                saleLine.productSecurity.isDisabled = false;
                if (!isProductControl) {
                    saleLine.inventoryTypeSecurity.isDisabled = false;
                }
            });
            this.$rootScope.$emit(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, securityItem.key.replace(/:/gi, '_'), securityItem.displayName, this.identityService.current().userName, securityItem.securityKeyPath);
        }

        checkVoidSecurity(item) {
            if (this.voidTransactionSecurity.securityAccess === Model.SecurityAccessEnum.Grant) {
                this.voidTransaction(item);
            }
            else if (this.voidTransactionSecurity.securityAccess === Model.SecurityAccessEnum.Deny) {
                let defer = this.$q.defer();
                defer.promise.then(() => {
                    this.voidTransaction(item);
                });
                this.$rootScope.$emit(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, this.voidTransactionSecurity.key.replace(/:/gi, '_'),
                    this.voidTransactionSecurity.displayName, this.identityService.current().userName, this.voidTransactionSecurity.securityKeyPath);
            }
        }

        canShowVoidAction(item) {
            return this.voidTransactionSecurity && this.voidTransactionSecurity.securityAccess !== Model.SecurityAccessEnum.Hide && item.canVoid;
        }

        loadSale(transItem) {
            this.showSaveMessage = false;

            transItem.detail.saleLines.forEach((saleLine: Model.TransactionEditorSaleLine) => {
                switch (saleLine.clientType) {
                    case Model.ClientTypeEnum.AnonymousFemale:
                    case Model.ClientTypeEnum.AnonymousMale:
                    case Model.ClientTypeEnum.AnonymousOther:
                        saleLine.client = { displayName: this.getAnonymousClientName(saleLine.clientType) };
                        break;
                }

                switch (saleLine.saleType) {
                    case Model.SalesTypeEnum.Service:
                        saleLine.service = saleLine.item;
                        break;

                    case Model.SalesTypeEnum.Product:
                        // Item may be null if sale inserted in past with product so need to dummy one up.
                        saleLine.item = saleLine.item || { productDisplayName: "" };
                        saleLine.product = saleLine.item;
                        saleLine.productCriteria = { ...this.productCriteria };
                        saleLine.item.tempProductInventoryType = saleLine.item.productInventoryType;
                        this.setProductSecurity(saleLine);
                        break;
                }

                this.employeeChanged(saleLine, false, false);
                this.setPurchasedForClient(saleLine);
                this.populateConsolidatedDiscounts(saleLine);
                this.populateProductUsageForDisplay(saleLine);
            });

            this.populatePaymentLines(transItem);
            this.populateTransactionNotes(transItem);
            this.groupSaleLinesByClient(transItem);
        }

        populateProductUsageForDisplay(saleLine: Model.SaleLine) {
            if (!saleLine.item || !saleLine.item.productUsage) {
                return;
            }
            const variants = (saleLine.item.productUsage && saleLine.item.productUsage.variants) || [];
            const redeemedPkgs = saleLine.redeemedPackages || [];
            const redeemedItemsArray = _.map(redeemedPkgs, pkg => pkg.packageItems);
            const redeemedItems = _.flatten(redeemedItemsArray);
            let usage = _.map(variants, (variant) => {
                const query = { "productVariantId": variant.variantId };
                const redeemed = _.where(redeemedItems, query);
                const list = [];
                if (redeemed.length == 0) {
                    list.push({
                        "displayName": this.getVariantDisplayName(variant),
                        "usageAmount": variant.usageAmount,
                        "unitOfMeasure": this.getUnitOfMeasure(variant.unitOfMeasure, variant.productUsageAmountType),
                        "packageNumber": "",
                    });
                }
                else {
                    for (const item of redeemed) {
                        list.push({
                            "displayName": variant.productSku,
                            "usageAmount": item.redeemQuantity,
                            "unitOfMeasure": this.getUnitOfMeasure(variant.unitOfMeasure, variant.productUsageAmountType),
                            "packageNumber": item.clientPackageNumber,
                        });
                    }
                }
                return list;
            });
            usage = _.flatten(usage);
            usage = _.sortBy(usage, (item: any) => {
                return item.displayName.toLowerCase();
            });
            saleLine["productUsageForDisplay"] = usage;
        }

        populateConsolidatedDiscounts(saleLine: Model.SaleLine) {
            if (!saleLine) {
                return;
            }

            _(saleLine.consolidatedDiscountLines).each(discountLine => {
                const regex = /{{([^}]+)}}/g;
                let displayName = discountLine.displayName;
                let match;
                while (match = regex.exec(displayName)) {
                    discountLine.displayName = discountLine.displayName.replace(match[0], this.$translate.instant(match[1]));
                }
            });
        }

        getAnonymousClientName(clientType: Meevo.Model.ClientTypeEnum) {
            switch (clientType) {
                case Meevo.Model.ClientTypeEnum.AnonymousMale:
                    return this.$translate.instant("LABEL_ANONYMOUS_MALE");
                case Meevo.Model.ClientTypeEnum.AnonymousFemale:
                    return this.$translate.instant("LABEL_ANONYMOUS_FEMALE");
                default:
                    return this.$translate.instant("LABEL_ANONYMOUS_OTHER");
            }
        }

        productItemChanged(saleLine) {
            if (!saleLine.product) {
                return;
            }
            saleLine.item.baseProductInventoryType = saleLine.product.productInventoryType;
            this.itemChanged(saleLine.product);
        }

        serviceItemChanged(saleLine: Model.TransactionEditorSaleLine) {
            if (!saleLine.service) {
                return;
            }

            this.checkPostServiceCareNotification(saleLine);
            //store now so we can verify it changed
            saleLine.item.id = saleLine.service.id
            this.itemChanged(saleLine.service);
        }

        private checkPostServiceCareNotification(saleLine: Model.TransactionEditorSaleLine) {
            if (saleLine.service === undefined ||
                (saleLine.clientId === saleLine.client.id && (saleLine.service.id === saleLine.item.id || saleLine.clientType !== Model.ClientTypeEnum.Client))) {
                return;
            }

            this.isPostServiceCareNotificationEnabled(saleLine.client.id, saleLine.service.id).then(response => {
                const isEnabled = response.data;
                if (isEnabled) {
                    const hasAsked = angular.isDefined(saleLine.item.isPostServiceCareNotificationRequested)
                    if (!hasAsked) {
                        this.hasPostServiceCareNotificationBeenSent(saleLine.clientId, saleLine.computedGuid).then(response => {
                            const message = response.data ? "MESSAGE_TRANS_EDITOR_POST_SERVICE_CARE_NOTIFICATION_ALREADY_SENT" :
                                "MESSAGE_TRANS_EDITOR_POST_SERVICE_CARE_NOTIFICATION_NOT_SENT";
                            this.modalService.yellowConfirm(message).then(() => {
                                saleLine.item.isPostServiceCareNotificationRequested = true;
                            }).catch(() => {
                                saleLine.item.isPostServiceCareNotificationRequested = false;
                            })
                        })
                    }
                }
                else {
                    saleLine.item.isPostServiceCareNotificationRequested = undefined;
                }
            })
        }

        itemChanged(item) {
            if (item) {
                this.showSaveMessage = true;
            }
        }

        clientChanged(saleLine: Model.TransactionEditorSaleLine, changeType: string) {
            if (changeType === "ClientType") {
                if (saleLine.clientType && saleLine.clientType != Model.ClientTypeEnum.Client) {
                    if (this.saleLineHasLinkedIds(saleLine)) {
                        this.updatePackageUpgradeSwapFeeLine(saleLine, true);
                    }

                    this.showSaveMessage = true;
                    saleLine.clientId = undefined;
                    saleLine.client = {
                        id: undefined,
                        clientType: saleLine.clientType,
                        displayName: this.getAnonymousClientName(saleLine.clientType)
                    }
                }
            } else if (isObject(saleLine.client) && saleLine.client.id) {
                if (saleLine.clientId !== saleLine.client.id && this.saleLineHasLinkedIds(saleLine)) {
                    this.updatePackageUpgradeSwapFeeLine(saleLine, true);
                }

                this.checkPostServiceCareNotification(saleLine);
                this.showSaveMessage = true;
                saleLine.clientId = saleLine.client.id;
                saleLine.clientType = Model.ClientTypeEnum.Client;
            }
        }

        public toggleFilter = () => {
            this.isFilterHidden = !this.isFilterHidden;
        }

        setPurchasedForClient(saleLine) {
            if (!saleLine.item) {
                return;
            }

            if ((saleLine.item.giftCardNumber && !saleLine.item.purchasedForClientId)
                || (saleLine.item.clientPackage && !saleLine.item.clientPackage.client)) {
                this.useAnonymousClient(saleLine.item);
            }
        }

        expandCallback(index, id) {
            let page = this.transactionResults.pages[this.transactionResults.currentPage];
            if (page) {
                let transItem = page[index];
                if (!transItem.detail) {
                    this.getTransactionDetail(transItem).then(() => this.filterSurchargeablePaymentTypes(transItem));
                } else {
                    this.filterSurchargeablePaymentTypes(transItem);
                }
            }
        }

        collapseCallback(index, id) {
            if (this.isEditing) {
                return false;
            }
        }

        checkIfCanCollapse(evt, pane) {
            if (this.isEditing) {
                evt.preventDefault();
                evt.stopPropagation();
            } else {
                pane.toggle();
            }
        }

        keycheckIfCanCollapse(evt, pane) {
            if (this.isEditing/* && (evt.key == " " || evt.keyCode == 32)*/) {
                evt.preventDefault();
                evt.stopPropagation();
            } else if (pane) {
                pane.toggle();
            }
        }

        filterClientChanged() {
            if (this.client != null) {
                this.clients.push(this.client);
                this.criteria.clientIds.push(this.client.id);
                this.client = null;
            }
        }

        deleteClient(index) {
            if (this.clients.length > index) {
                this.clients.splice(index, 1);
                this.criteria.clientIds.splice(index, 1);
            }
        }

        filterEmployeeChanged() {
            this.criteria.employeeId = this.employee != null ? this.employee.id : null;
        }

        filterTeacherChanged() {
            this.criteria.teacherId = this.teacher ? this.teacher.id : null;
        }

        filterUserChanged() {
            this.criteria.createdById = this.user != null ? this.user.id : null;
        }

        filterDrawerChanged() {
            this.criteria.drawerId = this.drawer != null ? this.drawer.id : null;
        }

        filterPaymentTypeChanged() {
            this.criteria.paymentTypeId = this.paymentType != null ? this.paymentType.id : null;
        }

        onCompletedToggled() {
            if (this.criteria.includeCompleted) {
                this.criteria.includeOnHold = false;
            }
        }

        onRefundedToggled() {
            if (this.criteria.includeRefunded) {
                this.criteria.includeOnHold = false;
            }
        }

        onVoidedToggled() {
            if (this.criteria.includeVoided) {
                this.criteria.includeOnHold = false;
            }
        }

        onHoldToggled() {
            if (this.criteria.includeOnHold) {
                this.criteria.includeCompleted = false;
                this.criteria.includeRefunded = false;
                this.criteria.includeVoided = false;
                return;
            }

            this.criteria.archivedOnHold = false;
        }

        isItemLink(saleLine: Model.SaleLine): boolean {
            if (this.isEditing) {
                return false;
            }

            if (this.isGiftCardSaleLine(saleLine)) {
                if (this.securityGiftCardLookup === Model.SecurityAccessEnum.Hide) {
                    return false;
                }
                return true;
            }

            if (this.isPaymentPlanSaleLine(saleLine)) {
                return true;
            }

            return false;
        }

        getItemLinkSecurity(saleLine: Model.SaleLine) {
            if (!this.isItemLink(saleLine)) {
                return null;
            }

            if (this.isGiftCardSaleLine(saleLine)) {
                return this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDLOOKUP + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            }

            return null;
        }

        gotoItemLink(saleLine: Model.SaleLine) {
            if (!this.isItemLink(saleLine)) {
                return;
            }

            if (this.isGiftCardSaleLine(saleLine)) {
                const saleLineItem: any = saleLine.item;
                this.goToGiftCardBalanceModal(saleLineItem.id);
            }

            if (this.isPaymentPlanSaleLine(saleLine)) {
                this.transactionEditorController.paymentPlanService.goToPaymentPlanManager(saleLine.paymentPlanId || saleLine.item.id);
            }
        }

        isPaymentLink(payment: Model.SalePayment) {
            return this.isPaymentPlanLink(payment) || this.isGiftCardLink(payment);
        }

        isPaymentPlanLink(payment: Model.SalePayment) {
            return payment.paymentCategory === Model.PaymentCategoryEnum.PaymentPlan;
        }

        goToPaymentLink(payment: Model.SalePayment) {
            if (this.isPaymentPlanLink(payment)) {
                return this.transactionEditorController.paymentPlanService
                    .goToPaymentPlanManager((<Meevo.Plugins.Register.PaymentPlanSalePayment>payment).paymentPlanId);
            }

            if (this.isGiftCardLink(payment)) {
                return this.goToGiftCardBalanceModal((<Model.SaleGiftCardPayment>payment).giftCardId);
            }
        }

        goToDeferredVoidLink(payment: Model.SalePayment) {
            const salePaymentDeferredVoid = <Model.SalePaymentDeferredVoid>payment;
            this.goToTransactionEditor(salePaymentDeferredVoid.voidSaleTransactionId);
        }

        private cacheDeferredVoidLink(payment: Model.SalePaymentDeferredVoidKey, deferredVoidLinks: Model.SalePaymentKey[]): Model.SalePaymentKey {
            if (!payment.deferredVoidKey) {
                payment.deferredVoidKey = _(deferredVoidLinks).find(key => key.salePaymentId == payment.id);
            }

            return payment.deferredVoidKey;
        }

        goToDeferredVoidReturnLink(deferredVoidKey: Model.SalePaymentKey) {
            if (!deferredVoidKey) {
                return;
            }

            this.goToTransactionEditor(deferredVoidKey.saleTransactionId);
        }

        private goToTransactionEditor(transactionId: string) {
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: {
                    transactionId: transactionId,
                    includeActive: true,
                    includeCompleted: true,
                    includeOnHold: false,
                    includeRefunded: true,
                    includeVoided: true
                },
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        isGiftCardLink(payment: Model.SalePayment) {
            return payment.paymentCategory === Model.PaymentCategoryEnum.GiftCard;
        }

        isClientLink(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.clientType === Meevo.Model.ClientTypeEnum.Client && !!saleLine.clientId;
        }

        gotoClientLink(saleLine: Model.SaleLine) {
            if (!this.isClientLink(saleLine)) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: "client",
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: "transactionEditor",
                    id: saleLine.clientId,
                    initialEditSection: "SECTION_CLIENT_MAIN",
                    clientDisplayName: this.getClientDisplayName(saleLine)
                }
            });
        }

        returnFromHold(item) {
            if (item.transactionId.substr(0, 4) == "HOLD") {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: "register",
                    stateParams: {
                        action: Meevo.Components.Common.Messages.RETURN_FROM_ON_HOLD,
                        id: item.transactionGuid
                    }
                });
                return this.dataService.trackUsage(Meevo.Model.NounEnum.TransactionEditorPage, Meevo.Model.VerbEnum.ReturnFromOnHold, null, item.transactionGuid);
            }
        }

        refundReceipt(item) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.register,
                stateParams: {
                    action: Meevo.Components.Common.Messages.REGISTER_REFUND_RECEIPT,
                    transactionNumber: item.transactionId,
                }
            });
            return this.dataService.trackUsage(Meevo.Model.NounEnum.TransactionEditorPage, Meevo.Model.VerbEnum.RefundButtonClicked, null, item.transactionGuid);
        }

        private _nonVoidableDrawerTypes = [
            Model.DrawerTypeEnum.Membership,
            Model.DrawerTypeEnum.OnlineBooking,
        ];

        canVoidAsync(item): ng.IPromise<boolean> {
            if (!item) {
                return this.$q.resolve(false);
            }

            let deferred = this.$q.defer<boolean>();
            let isTransactionToday = moment().diff(item.saleDate, 'days') === 0;
            if (isTransactionToday && item.saleState !== Meevo.Model.SaleStateEnum.Void &&
                this._nonVoidableDrawerTypes.indexOf(item.drawerType) === -1) {
                let detailPromise: ng.IPromise<void> = (!item.detail) ? this.getTransactionDetail(item) : this.$q.resolve();
                detailPromise.then(() => {
                    let promises: ng.IPromise<boolean>[] = [
                        this.canVoidPaymentPlan(item),
                        this.canVoidMerchantPayment(item),
                    ];
                    this.$q.all(promises).then((result : boolean[]) => {
                        this.resolveCanVoidDeferred(deferred, result[0] && result[1], item);
                    })
                })
            }
            else {
                this.resolveCanVoidDeferred(deferred, false, item);
            }
            return deferred.promise;
        }

        private canVoidPaymentPlan(item): ng.IPromise<boolean> {
            // not sure if in reqs, but according to Al, can't void payment plan bill
            if (_(item.detail.saleLines).any((saleLine: Model.SaleLine) =>
                saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPayment ||
                saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPaymentEFT ||
                (saleLine.isRefund && !_(saleLine.paymentPlanId).isEmpty())
            )) {
                return this.$q.resolve(false);
            }

            let paymentPlanPayment = _(item.detail.paymentLines).find((paymentLine: Model.SalePayment) =>
                paymentLine.paymentCategory === Model.PaymentCategoryEnum.PaymentPlan && paymentLine.amount > 0
            );

            if (!paymentPlanPayment) {
                return this.$q.resolve(true);
            }

            return this.dataService.customMethodData(`/api/paymentPlan/${paymentPlanPayment.paymentPlanId}`, "GET", null).then(response =>
                //Obligation could have changed if manual payment made.  Shouldn't be a pending bill since
                //can't be billed same day, but leaving just in case.
                !response.data.hasObligationChanged && !response.data.hasPendingBill
            );
        }

        private canVoidMerchantPayment(item) : ng.IPromise<boolean> {
            // not voidable if deferred void payment line exists
            const hasDeferredVoidPaymentLines = _(item.detail.paymentLines).some(paymentLine => paymentLine.paymentCategory === Model.PaymentCategoryEnum.DeferredVoid);
            if (hasDeferredVoidPaymentLines) {
                return this.$q.resolve(false);
            }

            // voidable if credit card lines don't exist
            const creditPaymentLines = _(item.detail.paymentLines).filter(paymentLine => !!paymentLine.paymentRequest && paymentLine.paymentRequest.merchantAccountId);
            if (!creditPaymentLines || creditPaymentLines.length === 0) {
                return this.$q.resolve(true);
            }

            const merchantAccountId = creditPaymentLines[0].paymentRequest.merchantAccountId;

            function isVoidable(capabilities): boolean {
                if (!capabilities.canVoidTransactions) {
                    return false;
                }

                const hasCreditRefundPaymentLine = _(creditPaymentLines).some(paymentLine => paymentLine.amount < 0);
                if (hasCreditRefundPaymentLine) {
                    return capabilities.canVoidRefunds;
                }

                return true;
            }

            var cacheResult = this.merchantCanVoidHash[merchantAccountId];
            if (cacheResult) {
                return this.$q.resolve(isVoidable(cacheResult));
            }

            return this.dataService.customMethodData(`api/merchantAccount/${merchantAccountId}`, "GET", null).then((response) => {
                let capabilities = {
                    canVoidTransactions: false,
                    canVoidRefunds: false,
                };

                // if can't find merchant, canVoid* settings should remain false since we'll be unable to void the PR
                if (response && response.data) {
                    capabilities.canVoidTransactions = response.data.canVoidTransactions;
                    capabilities.canVoidRefunds = response.data.canVoidRefunds;
                }

                this.merchantCanVoidHash[merchantAccountId] = capabilities;

                return isVoidable(capabilities);
            });
        }

        resolveCanVoidDeferred(canVoidDefer: ng.IDeferred<boolean>, canVoid: boolean, item) {
            item.canVoid = canVoid && item.detail && item.detail.canVoid;
            canVoidDefer.resolve(canVoid);
        }

        isMembershipTransaction(item): boolean {
            return item.hasMembershipPayment === true || item.drawerType === Meevo.Model.DrawerTypeEnum.Membership;
        }

        hasRefundToPaymentPlan(item : Model.Sale): boolean {
            return _(item.saleLines).any((saleLine: Model.SaleLine) => {
                return saleLine.hasPaymentPlan && saleLine.isRefund;
            });
        }

        voidCreditCardPayments(item) {
            this.busyService.start();
            this.dataService.customMethodData(`api/sale/${item.transactionId}/void`, 'POST', null).then(response => {
                this.checkForCreditCardPaymentWarning(response).then(() => {
                    this.forcePageLoading(this.criteria);
                });
            }).finally(() => {
                this.busyService.stop();
            });
        }

        private voidTransaction(item) {
            if (!item.canVoid) {
                return;
            }

            if (this.isMembershipTransaction(item)) {
                this.modalService.alert("MESSAGE_TRANSACTIONEDITOR_CANNOT_VOID_MEMBERSHIP");
                return;
            }

            if (this.hasRefundToPaymentPlan(item)) {
                this.modalService.alert("MESSAGE_NO_VOID_REFUND_TO_PAYMENT_PLAN");
                return;
            }

            let message = item.hasCreditCardPayment
                ? this.$translate.instant("MESSAGE_VOID_TRANSACTION_WITH_CREDIT_CARD_PAYMENTS", { transactionId: item.transactionId })
                : this.$translate.instant("MESSAGE_TRANSACTIONEDITOR_CONFIRM_VOID");

            const modalOptions = {
                showCancelButton: true,
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON',
                okButtonContentKey: 'LABEL_YES'
            };

            this.modalService.warning(message, Components.Modal.ModalTranslationModes.DoNotTranslate, false, modalOptions).then(response => {
                if (!response) {
                    return;
                }

                this.busyService.start();
                this.dataService.customMethodData(`api/sale/${item.transactionId}/void`, 'POST', null)
                    .then((response) => {
                        this.tippyService.voidTransaction(item.externalTipTransactionId);
                        this.checkForCreditCardPaymentWarning(response).then((checkResponse) => {
                            let promise: ng.IPromise<any>;
                            if (response.status != 409) {
                                let paymentRequests: Model.PaymentRequest[] = checkResponse.data;
                                // print CC void receipts
                                promise = paymentRequests.length > 0
                                    ? this.printCreditCardReceipts(paymentRequests, true)
                                    : this.$q.resolve();
                            }
                            else {
                                promise = this.$q.resolve();
                            }
                            promise.then(() =>
                                this.showReceiptModal(item).then(() =>
                                this.handleReceipt(item).then(() =>
                                this.forcePageLoading(this.criteria)))
                            );
                        });
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            });
        }

        insertTransaction() {
            const insertTransactionCallback = (pastTransactionContext: Meevo.Model.PastTransactionContext) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.register,
                    stateParams: {
                        action: Meevo.Components.Common.Messages.TRANSACTION_EDITOR_INSERT,
                        pastTransactionContext: pastTransactionContext,
                    }
                });
            };

            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/transactionEditor/insertTransaction/insertTransactionModal.template.html",
                controller: "meevo.plugins.transactionEditor.InsertTransactionModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    startDateTime: this.criteria.startDateTime,
                    isCheckout: false,
                    callback: insertTransactionCallback,
                }
            };

            return this.modalService.showCustom(modalOptions);
        }

        showDeferredVoidModal(transItem, salePayment: Meevo.Model.SalePayment) {
            const sale = transItem.detail;

            const paymentType = _(this.allPaymentTypes).find(paymentType =>
                paymentType.paymentCategory === Model.PaymentCategoryEnum.DeferredVoid &&
                paymentType.paymentSubCategory === Model.PaymentSubCategoryEnum.DeclinedCardRefund);

            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/transactionEditor/deferredVoid/deferredVoidModal.template.html",
                controller: "meevo.plugins.transactionEditor.DeferredVoidModalController",
                controllerAs: "vm",
                bindToController: true,
                multiple: true,
                locals: {
                    sale,
                    salePayment,
                    paymentLineDisplayName: this.getPaymentDisplayName(salePayment),
                    houseEmployee: this.HouseEmployee,
                    paymentType,
                }
            };

            return this.modalService.showCustom(modalOptions).then((item: Model.Sale | boolean) => {
                if (!item) {
                    return;
                }

                const sale = item as Model.Sale;
                if (!sale || !sale.transactionId) {
                    return this.modalService.alert("LABEL_ERROR");
                }

                this.showReceiptModal(item).then(() =>
                this.handleReceipt(item).then(() =>
                this.forcePageLoading(this.criteria)))

                return this.$q.resolve(true);
            });
        }

        checkForCreditCardPaymentWarning(response): ng.IPromise<any> {
            if (response.status == 409) {
                return this.modalService.alert(response.data.responseStatus.message,
                    Components.Modal.ModalTranslationModes.DoNotTranslate);
            } else {
                return this.$q.resolve(response);
            }
        }

        showReceiptModal(item): angular.IPromise<any> {
            this.sale = item;
            this.selectedDrawer = {};
            this.selectedDrawer.receiptTypeEnum = Model.RegisterReceiptTypeEnum.PromptReceipt;

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/modal.template.html",
                controller: "meevo.plugins.register.ModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    registerContext: this,
                    modalType: Meevo.Plugins.Register.RegisterModalTypeEnum.Receipt
                }
            }

            return this.modalService.showCustom(options);
        }

        public handleReceipt(item): ng.IPromise<any> {
            let defer = this.$q.defer();

            if (this.receiptPreference == Model.RegisterReceiptTypeEnum.PrintReceipt) {
                defer.resolve(this.printReceipt(item, PrintTypeEnum.Receipt));
            }
            else if (this.receiptPreference == Model.RegisterReceiptTypeEnum.EmailReceipt && this.isEmailEnabled) {
                defer.resolve(this.emailReceipt(item, PrintTypeEnum.Receipt));
            }
            else if (this.receiptPreference == Model.RegisterReceiptTypeEnum.PrintEmailReceipt) {
                defer.resolve(this.$q.all([
                    this.printReceipt(item, PrintTypeEnum.Receipt),
                    this.emailReceipt(item, PrintTypeEnum.Receipt)
                ]));
            }
            else {
                defer.resolve();
            }

            return defer.promise;
        }

        // Sends email notifications based on types i.e. Sale Created ( receipt ) , Gift Receipt created ( gift receipt ), insurance receipt
        receiptNotification(transItem: any, type: Meevo.Model.CommunicationTypeEnum, selectedEmail: string = "", showCopy: boolean = false, excludeSaleLineIds?: Number[]) {
            let saleDate = moment(transItem.saleDate).format("YYYY-MM-DD").toString();
            let communicationType = type;
            let communicationMethod = Meevo.Model.CommunicationMethodEnum.Email;
            let saleid = parseInt(transItem.id);

            let data = {
                id: saleid,
                emailId: selectedEmail,
                saleId: saleid,
                saleDate: saleDate,
                CommunicationType: communicationType,
                communicationMethod: communicationMethod,
                clientId: null,
                showCopy: showCopy,
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT,
                excludeSaleLineIds: excludeSaleLineIds,
            };

            if (saleid) {
                let url = `api/sale/${saleid}/notification`;

                this.busyService.start();
                return this.dataService.customMethodData(url, "POST", data)
                    .finally(() => {
                        this.busyService.stop();
                    });
            }
        }

        email(item: any, printType: PrintTypeEnum, emailAddress: string = ""): ng.IPromise<any> {
            if (printType == PrintTypeEnum.Receipt) {
                this.dataService.trackUsage(Meevo.Model.NounEnum.TransactionEditorPage, Meevo.Model.VerbEnum.EmailReceiptButtonClicked, null, item.transactionGuid);
            }

            const sendEmail = (excludeSaleLineIds?: Number[]) => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: 'app/plugins/client/sectionViews/selectEmail.modal.html',
                    controller: 'meevo.plugins.client.SelectEmailController',
                    controllerAs: "vm",
                    bindToController: true,
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {
                        email: emailAddress,
                        validateRegex: true
                    }
                }

                return this.modalService.showCustom(options).then(selectedEmail => {
                    switch (printType) {
                        case PrintTypeEnum.Receipt:
                            return this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.SaleCreated, selectedEmail, true);
                        case PrintTypeEnum.GiftReceipt:
                            return this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.GiftReceiptCreated, selectedEmail, true, excludeSaleLineIds);
                        case PrintTypeEnum.InsuranceReceipt:
                            return this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.InsuranceReceiptCreated, selectedEmail, false);
                    }
                });
            }

            if (printType == PrintTypeEnum.GiftReceipt) {
                return this.showGiftReceiptPreview(item).then((excludeSaleLineIds: Number[]) => {
                    if (!excludeSaleLineIds) {
                        return this.$q.resolve();
                    }
                    return sendEmail(excludeSaleLineIds);
                });
            }

            return sendEmail();
        }

        printCreditCardReceipts(paymentRequests: Model.PaymentRequest[], isVoid: boolean = false) {
            const voidStr = isVoid ? "Void" : "";
            const urlWithDataList: Meevo.Components.Common.IHttpRequestObject[] = [];

            paymentRequests.forEach((obj) => {
                urlWithDataList.push({
                    url: `/api/PaymentRequest/${obj.id}/ClientCreditCard${voidStr}Receipt`,
                    method: "GET",
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                    }
                });
                urlWithDataList.push({
                    url: `/api/PaymentRequest/${obj.id}/MerchantCreditCard${voidStr}Receipt`,
                    method: "GET",
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                    }
                });
            });

            return this.printService.printCustom(...urlWithDataList);
        }

        printReceipt(transItem, printType: PrintTypeEnum): ng.IPromise<any> {
            // Force md-menu to close after making selection, with enough time for selection animation
            setTimeout(() => {
                angular.element('.md-open-menu-container').hide();
            }, 300);

            if (printType == PrintTypeEnum.InsuranceReceipt &&
                _.where(transItem.detail.saleLines, { clientType: Meevo.Model.ClientTypeEnum.Client }).length == 0) {
                return this.$q.resolve();
            }

            let showCopy = true;
            let urlWithDataList: Meevo.Components.Common.IHttpRequestObject[] = [];
            let promise: ng.IPromise<any> = null;

            const finish = (printType: PrintTypeEnum, payload: any = null) => {
                if (printType == PrintTypeEnum.MerchantCreditCardReceipt || printType == PrintTypeEnum.MerchantCreditCardVoidReceipt) {
                    let detailPromise: ng.IPromise<any> = transItem.detail
                        ? this.$q.resolve()
                        : this.getTransactionDetail(transItem);

                    promise = detailPromise.then(() => {
                        transItem.detail.paymentLines.forEach((pl: Model.SalePayment) => {
                            if (pl.paymentCategory !== Model.PaymentCategoryEnum.CreditDebit) {
                                return;
                            }

                            let paymentRequestId = (pl as Model.SaleCreditCardPayment).paymentRequestId;
                            if (paymentRequestId) {
                                urlWithDataList.push({
                                    url: `/api/PaymentRequest/${paymentRequestId}/${PrintTypeEnum[printType]}`,
                                    method: "GET",
                                    params: {
                                        locale: this.appSettings.APP_COUNTRYID,
                                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                                    }
                                });
                            }
                        });
                    });
                } else if (printType === PrintTypeEnum.HoldReceipt) {
                    urlWithDataList.push({
                        url: `/api/SaleHold/${transItem.transactionGuid}/Receipt`,
                        method: 'GET',
                        params: {
                            showCopy: false,
                            locale: this.appSettings.APP_COUNTRYID,
                            timeFormat: this.appSettings.APP_TIME_FORMAT
                        }
                    });

                    promise = this.$q.resolve();
                }else {
                    let receiptUrl: string = `api/sale/${transItem.transactionId}/${PrintTypeEnum[printType]}`;
                    let method = 'GET';

                    if (printType === PrintTypeEnum.InsuranceReceipt) {
                        receiptUrl += "/List";
                        showCopy = false;
                    } else if (printType === PrintTypeEnum.Receipt) {
                        let labelPaymentCheck = this.$translate.instant("LABEL_PAYMENT_TYPE_2279");

                        if (labelPaymentCheck != "LABEL_PAYMENT_TYPE_2279") {
                            payload = {
                                localeDictionary: {
                                    "LABEL_PAYMENT_TYPE_2279": labelPaymentCheck
                                }
                            }
                            method = "POST";
                        }
                    } else if (printType === PrintTypeEnum.GiftReceipt && payload) {
                        method = 'POST';
                    }

                    payload = payload || {};

                    urlWithDataList.push({
                        url: receiptUrl,
                        method: method,
                        params: {
                            showCopy: showCopy,
                            locale: this.appSettings.APP_COUNTRYID,
                            timeFormat: this.appSettings.APP_TIME_FORMAT,
                        },
                        data: payload
                    });

                    promise = this.$q.resolve();
                }

                return promise.then(() => {
                    if (urlWithDataList.length > 0) {
                        return this.printService.printCustom(...urlWithDataList).then(() => {
                            return this.dataService.trackUsage(Meevo.Model.NounEnum.TransactionEditorPage, Meevo.Model.VerbEnum.PrintReceiptButtonClicked, null, transItem.transactionGuid);
                        });
                    }
                });
            }

            if (printType === PrintTypeEnum.GiftReceipt) {
                this.showGiftReceiptPreview(transItem).then(excludeSaleLineIds => {
                    if (!excludeSaleLineIds) {
                        return this.$q.resolve(null);
                    }
                    return finish(printType, { excludeSaleLineIds: excludeSaleLineIds });
                })
            } else {
                return finish(printType);
            }
        }

        emailReceipt(transItem: any, printType: PrintTypeEnum): ng.IPromise<any> {
            if (!this.isEmailEnabled) {
                return this.$q.resolve();
            }

            if (printType == PrintTypeEnum.InsuranceReceipt &&
                _.where(transItem.detail.saleLines, { clientType: Meevo.Model.ClientTypeEnum.Client }).length == 0) {
                return this.$q.resolve();
            }

            let continueEmail = () => {
                return this.email(transItem, printType, (transItem.detail.saleLines.length > 0 && transItem.detail.saleLines[0].client) ? transItem.detail.saleLines[0].client.emailAddress : "");
            };

            if (transItem.detail) {
                return continueEmail();
            } else {
                return this.getTransactionDetail(transItem).then(() => {
                    return continueEmail()
                });
            }
        }

        get printTypeEnum(): any {
            return PrintTypeEnum;
        }

        get discountNoteType() { return Model.SaleNoteTypeEnum.Discount; }

        editTransaction(transItem, $pane) {
            if (this.isEditing) {
                return false;
            }

            this.isEditing = transItem.isEditable;

            if (!$pane.isExpanded()) {
                $pane.expand();
            } else {
                this.filterSurchargeablePaymentTypes(transItem);
            }

            this.modifiedPaymentLines = [];
            this.isEditingPermanentlyEditableFields = true;
        }

        setTransactionNote(transItem) {
            if (transItem.detail.transactionNote) {
                let saleNote = _(transItem.detail.saleNotes).find((note) => note.noteType === Model.SaleNoteTypeEnum.Transaction || note.noteType === Model.SaleNoteTypeEnum.Discount);
                //when adding new Note, need to add it in main list
                if (!saleNote && transItem.detail.transactionNote) {
                    transItem.detail.transactionNote.noteType = transItem.detail.transactionNote.noteType || Model.SaleNoteTypeEnum.Transaction;
                    transItem.detail.saleNotes.push(transItem.detail.transactionNote);
                }
            }
        }

        isNoteLengthValid(transItem) {
            let refundOriginalNote = _(transItem.detailCopy.saleNotes).find((note) => note.noteType === Model.SaleNoteTypeEnum.Refund);
            if (refundOriginalNote && transItem.detail.refundNote.noteText.length == 0) {
                return false;
            }
            let saleOriginalNote = _(transItem.detailCopy.saleNotes).find((note) => note.noteType === Model.SaleNoteTypeEnum.Transaction || note.noteType === Model.SaleNoteTypeEnum.Discount);
            if (saleOriginalNote && transItem.detail.transactionNote.noteText.length == 0) {
                return false;
            }
            return true;
        }

        getEditTransactionNoteLabel(transItem) {
            let label = this.$translate.instant("LABEL_TRANSACTION_NOTE");
            if (transItem.detail && transItem.detail.transactionNote) {
                label += ((this.isDiscountNote(transItem.detail.transactionNote)) ? "(" + this.$translate.instant("LABEL_DISCOUNT_NOTE_IN_REPORT") + ")" : "");
            }
            return label;
        }

        cancelEdit(transItem) {
            this.modifiedPaymentLines = [];
            transItem.detail = angular.copy(transItem.detailCopy);
            this.isEditing = false;
            this.isEditingPermanentlyEditableFields = false;
        }

        saveTransaction(transItem) {
            this.$timeout(() => {
                if (this.modifiedPaymentLines.length > 0) {
                    this.modifiedPaymentLines.forEach((p, i) => {
                        if (p) {
                            transItem.detail.paymentLines.splice(i, 1, p);
                        }
                    });
                }

                let isInvalid = false;
                transItem.detail.saleLines.forEach(saleLine => {
                    switch (saleLine.saleType) {
                        case Model.SalesTypeEnum.Service:
                            if (saleLine.service) {
                                (<Meevo.Plugins.Register.BaseSaleLineItem>saleLine.item).id = saleLine.service.id;
                            }
                            break;
                        case Model.SalesTypeEnum.Product:
                            if (saleLine.product) {
                                (<Meevo.Plugins.Register.BaseSaleLineItem>saleLine.item).id = saleLine.product.id;
                            }
                            else {
                                isInvalid = true;
                            }
                            break;
                    }
                });
                if (isInvalid) {
                    return;
                }
                if (!this.isSplitCommissionValid(transItem)) {
                    return;
                }
                if (!this.isNoteLengthValid(transItem)) {
                    return;
                }
                this.setTransactionNote(transItem);

                var promiseMessage: ng.IPromise<boolean> = null;
                if (_.any(transItem.detail.saleLines, (sl: Model.SaleLine) => sl.isFullCommissionApplicableManuallyChecked)) {
                    promiseMessage = this.modalService.alert("MESSAGE_TRANS_EDITOR_FULL_COMMISSION_CHANGE", Components.Modal.ModalTranslationModes.Translate);
                } else {
                    promiseMessage = this.$q.resolve(true);
                }

                promiseMessage.then((alertResponse) => {
                    if (this.showSaveMessage) {
                        promiseMessage = this.modalService.alert("MESSAGE_TRANS_EDITOR_GENERAL_CHANGE");
                    } else {
                        promiseMessage = this.$q.resolve(true);
                    }

                    promiseMessage.then(() => {
                        this.dataService.update("sale", transItem.detail, transItem.transactionId, " ")
                            .then((response: Model.Sale) => {
                                transItem.detail = response;
                                this.loadSale(transItem);
                                transItem.detailCopy = angular.copy(transItem.detail);
                                transItem.updatedByDisplayName = this.identityService.current().userName;
                            })
                            .catch(() => {
                                // unsure of state of data, retrieve latest from server
                                this.getTransactionDetail(transItem);
                            });

                        this.isEditing = false;
                        this.isEditingPermanentlyEditableFields = false;
                    });
                });
            });
        }

        showTipModal(transItem) {
            this.sale = transItem.detail;

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/modal.template.html",
                controller: "meevo.plugins.register.ModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    registerContext: this,
                    modalType: Meevo.Plugins.Register.RegisterModalTypeEnum.TipChangeDueTransactionEditor
                }
            }

            return this.modalService.showCustom(options);
        }

        recalculateChangeDue() {
            this.sale.changeDue = this.sale.totalPayments - this.sale.total;
        }

        closeModal(receiptPreference: Model.RegisterReceiptTypeEnum = Model.RegisterReceiptTypeEnum.NoReceipt) {
            this.receiptPreference = receiptPreference;
            this.$mdDialog.hide();
        }

        isEmployeeHouseEmployee(employee): boolean {
            return (employee ? (employee.displayName == this.HouseEmployee.displayName && Guid.empty.equals(new Guid(employee.id))) : false);
        }

        isSpecialEmployeeMatched(filter: string, employeeEntityType: Model.EmployeeEntityTypeEnum): boolean {
            let isMatched = (filter.length == 0);
            if (!isMatched) {
                let pattern = filter.replace("_", ".").replace("%", "");
                let re = new RegExp(pattern, "i");
                isMatched = re.test(employeeEntityType != Model.EmployeeEntityTypeEnum.Teacher ? this.HouseEmployee.displayName : this.UnassignedTeacher.displayName) ||
                    (employeeEntityType != Model.EmployeeEntityTypeEnum.Teacher ? re.test(this.HouseEmployee.code) : false);
            }
            return isMatched;
        }

        employeeTypeAheadPreProcessData(responseData, requestData, isSecondEmployee = false, otherEmployee = null): any[] {
            if (requestData.pageNumber == 0) {
                if (this.isSpecialEmployeeMatched(requestData.criteria.filter, Model.EmployeeEntityTypeEnum.Employee) && !this.isEmployeeHouseEmployee(otherEmployee) && (isSecondEmployee || !otherEmployee)) {
                    responseData.splice(0, 0, this.HouseEmployee);
                }
                return responseData;
            }
        }

        teacherTypeAheadPreProcessData(responseData, requestData) {
            if (requestData.pageNumber == 0 && requestData.criteria.employeeEntityTypeEnum == Model.EmployeeEntityTypeEnum.Teacher &&
                this.isSpecialEmployeeMatched(requestData.criteria.filter, Model.EmployeeEntityTypeEnum.Teacher)) {
                responseData.splice(0, 0, this.UnassignedTeacher);
            }
        }

        getDrawerDisplayName(transItem) {
            return transItem.drawerType === Model.DrawerTypeEnum.Register ? transItem.drawerName : Model.DrawerTypeEnum[transItem.drawerType];
        }

        getPaymentPlanDisplayNameParts(saleLine: Model.SaleLine) {
            if (!saleLine) {
                return '';
            }

            return saleLine.item.displayName.split("##SALE_TRANSACTION_ID##");
        }

        getItemDisplayName(saleLine: Model.SaleLine) {
            if (!saleLine) {
                return '';
            }

            let isPaid = (saleItem) => {
                switch (saleItem.clientMembershipBillStatus) {
                    case Meevo.Model.ClientMembershipBillStatusEnum.Paid:
                    case Meevo.Model.ClientMembershipBillStatusEnum.Refund: {
                        return true;
                    }
                }
                return false;
            }

            let isWaived = (saleItem) => {
                switch (saleItem.clientMembershipBillStatus) {
                    case Meevo.Model.ClientMembershipBillStatusEnum.WaivedAccrued:
                    case Meevo.Model.ClientMembershipBillStatusEnum.WaivedNotAccrued: {
                        return true;
                    }
                }
                return false;
            }

            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.Service:
                case Model.SalesTypeEnum.ServiceNoShowFee:
                case Model.SalesTypeEnum.ServiceCancellationFee: {
                    let serviceSaleItem = saleLine.item as Model.ServiceSaleLineItem;
                    if (!serviceSaleItem) {
                        break;
                    }
                    return (serviceSaleItem.shortcut ? serviceSaleItem.shortcut + " - " : "")
                        + serviceSaleItem.displayName;
                }

                case Model.SalesTypeEnum.Product: {
                    let productSaleItem = saleLine.item as Model.ProductSaleLineItem;
                    if (!productSaleItem) {
                        break;
                    }
                    return (productSaleItem.sku ? productSaleItem.sku + " - " : "")
                        + productSaleItem.productDisplayName
                        + (productSaleItem.variantDisplayName ? " | " + productSaleItem.variantDisplayName : "")
                        + (productSaleItem.barCode ? " - " + productSaleItem.barCode : "")
                        ;
                }

                case Model.SalesTypeEnum.Package: {
                    let packageSaleItem = saleLine.item as Model.PackageSaleLineItem;
                    if (!packageSaleItem) {
                        break;
                    }
                    if (packageSaleItem.clientPackage.packageCreationType === Meevo.Model.PackageCreationTypeEnum.Custom) {
                        packageSaleItem.displayName = this.$translate.instant("LABEL_CUSTOM_PACKAGE");
                    }
                    return `${packageSaleItem.displayName} - ${packageSaleItem.packageNumber}`;
                }

                case Model.SalesTypeEnum.GiftCard:
                case Model.SalesTypeEnum.ReloadGiftCard: {
                    let giftCardSaleItem = saleLine.item as Model.GiftCardSaleLineItem;
                    if (!giftCardSaleItem) {
                        break;
                    }
                    let giftCardText = this.$translate.instant("LABEL_GIFT_CARD");
                    return `${giftCardText} - ${giftCardSaleItem.giftCardNumber}`;
                }
                case Model.SalesTypeEnum.BulkGiftCard:
                    let bulkGiftCardSaleItem = saleLine.item as Model.GiftCardBulkSaleLineItem;
                    if (!bulkGiftCardSaleItem) {
                        break;
                    }
                    return `#${bulkGiftCardSaleItem.giftCardNumberStarting} - #${bulkGiftCardSaleItem.giftCardNumberEnding}`;
                case Model.SalesTypeEnum.PromoGiftCard: {
                    let giftCardSaleItem = saleLine.item as Model.GiftCardSaleLineItem;
                    if (!giftCardSaleItem) {
                        break;
                    }
                    return (giftCardSaleItem && giftCardSaleItem.giftCardTypeDisplayName) ? giftCardSaleItem.giftCardTypeDisplayName : giftCardSaleItem.displayName;
                }

                case Model.SalesTypeEnum.Membership: {
                    let membershipSaleItem = saleLine.item as Model.MembershipSaleLineItem;
                    if (!membershipSaleItem) {
                        break;
                    }
                    return (membershipSaleItem.shortcut ? membershipSaleItem.shortcut + " - " : "")
                        + membershipSaleItem.displayName + " - " + membershipSaleItem.membershipNumber;
                }

                case Model.SalesTypeEnum.MembershipPaymentEFT: {
                    let membershipPaymentSaleItem = saleLine.item as Model.MembershipPaymentSaleLineItem;
                    if (!membershipPaymentSaleItem) {
                        break;
                    }
                    let membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_AUTO_EFT_PAYMENT");

                    switch (membershipPaymentSaleItem.clientMembershipBillFeeType) {
                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.FreezeFee:
                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.PaidInFullFreezeFee:
                            if (isPaid(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_AUTO_FREEZE_FEE_PAYMENT");
                            }
                            break;

                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.RecurringFee: {
                            if (isPaid(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_AUTO_EFT_PAYMENT");
                            }
                            break;
                        }

                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.RenewalFee: {
                            if (isPaid(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_AUTO_RENEWAL_EFT_PAYMENT");
                            }
                            break;
                        }
                    }

                    let paymentDate = this.meevoDateFilter(moment(membershipPaymentSaleItem.paymentDate).toDate());
                    //let paymentDate = moment(membershipPaymentSaleItem.paymentDate).format("M-D-YYYY");
                    return (membershipPaymentSaleItem.membershipName ? membershipPaymentSaleItem.membershipName + " - " : "") +
                        `${membershipPaymentText} - ${paymentDate}`;
                }

                case Model.SalesTypeEnum.MembershipWaive: {
                    let membershipPaymentSaleItem = saleLine.item as Model.MembershipPaymentSaleLineItem;
                    if (!membershipPaymentSaleItem) {
                        break;
                    }
                    let membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_EFT_PAYMENT");

                    switch (membershipPaymentSaleItem.clientMembershipBillFeeType) {
                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.FreezeFee:
                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.PaidInFullFreezeFee: {
                            if (isWaived(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_FREEZE_FEE_PAYMENT");
                            }
                            break;
                        }

                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.RecurringFee: {
                            if (isWaived(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_EFT_PAYMENT");
                            }
                            break;
                        }

                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.RenewalFee: {
                            if (isWaived(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_RENEWAL_EFT_PAYMENT");
                            }
                            break;
                        }
                    }

                    let paymentDate = this.meevoDateFilter(moment(membershipPaymentSaleItem.paymentDate).toDate());
                    //let paymentDate = moment(membershipPaymentSaleItem.paymentDate).format("M-D-YYYY");
                    return (membershipPaymentSaleItem.membershipName ? membershipPaymentSaleItem.membershipName + " - " : "") +
                        `${membershipPaymentText} - ${paymentDate}`;
                }

                case Model.SalesTypeEnum.MembershipPayment: {
                    let membershipPaymentSaleItem = saleLine.item as Model.MembershipPaymentSaleLineItem;
                    if (!membershipPaymentSaleItem) {
                        break;
                    }
                    let membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_MANUAL_EFT_PAYMENT");

                    switch (membershipPaymentSaleItem.clientMembershipBillFeeType) {
                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.FreezeFee:
                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.PaidInFullFreezeFee:
                            if (isPaid(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_MANUAL_FREEZE_FEE_PAYMENT");
                            }
                            else if (isWaived(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_FREEZE_FEE_PAYMENT");
                            }
                            break;

                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.RecurringFee: {
                            if (isPaid(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_MANUAL_EFT_PAYMENT");
                            }
                            else if (isWaived(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_EFT_PAYMENT");
                            }
                            break;
                        }

                        case Meevo.Model.ClientMembershipBillFeeTypeEnum.RenewalFee: {
                            if (isPaid(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_MANUAL_RENEWAL_EFT_PAYMENT");
                            }
                            else if (isWaived(membershipPaymentSaleItem)) {
                                membershipPaymentText = this.$translate.instant("LABEL_MEMBERSHIP_WAIVED_RENEWAL_EFT_PAYMENT");
                            }
                            break;
                        }
                    }

                    let paymentDate = this.meevoDateFilter(moment(membershipPaymentSaleItem.paymentDate).toDate());
                    //let paymentDate = moment(membershipPaymentSaleItem.paymentDate).format("M-D-YYYY");
                    return (membershipPaymentSaleItem.membershipName ? membershipPaymentSaleItem.membershipName + " - " : "") +
                        `${membershipPaymentText} - ${paymentDate}`;
                }

                case Model.SalesTypeEnum.ClientAccountCredit: {
                    let item = saleLine.item as Model.ClientAccountSaleLineItem;
                    let clientAccountCreditText = this.$translate.instant("LABEL_CLIENT_ACCOUNT_CREDIT_FOR");
                    return `${clientAccountCreditText}: ${item.clientDisplayName}`;
                }

                case Model.SalesTypeEnum.ClientAccountPayment: {
                    let item = saleLine.item as Model.ClientAccountSaleLineItem;
                    let clientAccountPaymentText = this.$translate.instant("LABEL_CLIENT_ACCOUNT_PAYMENT_FOR");
                    return `${clientAccountPaymentText}: ${item.clientDisplayName}`;
                }

                case Model.SalesTypeEnum.DepositCredit: {
                    let item = saleLine.item as Model.ClientAccountSaleLineItem;
                    let clientAccountCreditText = this.$translate.instant("LABEL_DEPOSIT_CREDIT_FOR", { serviceShortcut: item.serviceShortcut, clientDisplayName: item.clientDisplayName });
                    return clientAccountCreditText;
                }

                case Model.SalesTypeEnum.PackageServiceSwapFee: {
                    let packageServiceSwapFeePaymentText = this.$translate.instant("LABEL_PACKAGE_SERVICE_SWAP_FEE");
                    return packageServiceSwapFeePaymentText;
                }

                case Model.SalesTypeEnum.EgiftProcessingFee: {
                    let packageServiceSwapFeePaymentText = this.$translate.instant("LABEL_EGIFT_PROCESSING_FEE");
                    return packageServiceSwapFeePaymentText;
                }

                case Model.SalesTypeEnum.EgiftShippingFee: {
                    let packageServiceSwapFeePaymentText = this.$translate.instant("LABEL_EGIFT_SHIPPING_FEE");
                    return packageServiceSwapFeePaymentText;
                }

                case Model.SalesTypeEnum.PaymentSurcharge: {
                    return `${this.$translate.instant("LABEL_SURCHARGE")} (${saleLine.refundTransactionId})`;
                }
            }

            return saleLine.item ? (saleLine.item.displayName || saleLine.itemDisplayName) : saleLine.itemDisplayName;
        }

        isTipLineOnly(detail) {
            if (detail && detail.tipLines && detail.tipLines.length > 0) {
                if (detail.saleLines.length === 0) {
                    return true;
                }

                let allAssociatedClient = _(detail.saleLines).all(item => item.saleType === Model.SalesTypeEnum.AssociatedClient);
                return allAssociatedClient;
            }
            return false;
        }

        getFirstClientDisplayName(item) {
            let displayName = "";
            if (item) {
                displayName = item.firstClientType === Meevo.Model.ClientTypeEnum.Client
                    ? item.clientDisplayName
                    : this.getAnonymousClientName(item.firstClientType);
            }
            return displayName;
        }

        getClientDisplayName(saleLine: Model.SaleLine) {
            return saleLine.client
                ? saleLine.client.displayName
                : this.getAnonymousClientName(saleLine.clientType);
        }

        getPurchasedForClientDisplayName(saleClient: Model.SaleClient, isPackage: boolean = false) {
            if (saleClient && saleClient.id) {
                return saleClient.displayName;
            }

            return isPackage ? '' : this.$translate.instant('LABEL_GIFTCARD_PURCHASED_FOR_ANONYMOUS');
        }

        getEmployeeDisplayName(saleLine: Model.SaleLine) {
            if (saleLine.employeeId == null) {
                saleLine.employee = this.HouseEmployee;
                saleLine.employeeId = this.HouseEmployee.id;
            }
            return (saleLine.employee ? saleLine.employee.displayName : "");
        }

        getSecondEmployeeDisplayName(saleLine: Model.SaleLine) {
            return (saleLine.secondEmployee ? saleLine.secondEmployee.displayName : "");
        }

        getTransactionStatusDisplayName(item) {
            if (item.transactionStatus == 0) {
                return item.isHoldArchived ?
                    this.$translate.instant("LABEL_ARCHIVED_ON_HOLD") :
                    this.$translate.instant("LABEL_ON_HOLD");
            }
            else if (item.saleState === Model.SaleStateEnum.Void) {
                return this.$translate.instant("LABEL_VOID");
            }
            else {
                return this.$translate.instant("LABEL_COMPLETED");
            }
        }

        useAnonymousClient(item) {
            const client = {
                id: undefined,
                clientType: Model.ClientTypeEnum.AnonymousOther,
                displayName: this.$translate.instant("LABEL_GIFTCARD_PURCHASED_FOR_ANONYMOUS")
            };

            if (item.clientPackage) {
                item.clientPackage.client = client;
                item.clientPackage.clientId = undefined;
            } else {
                item.purchasedForClient = client;
                item.purchasedForClientId = undefined;
            }
        }

        teacherChanged(saleLine) {
            saleLine.teacherId = saleLine.teacher ? saleLine.teacher.id : undefined;
        }

        employeeChanged(saleLine: Model.TransactionEditorSaleLine, isSecondEmployee = false, fromTypeAhead = false) {
            if (saleLine.employee) {
                if (saleLine.employeeId !== saleLine.employee.id && this.saleLineHasLinkedIds(saleLine)) {
                    this.updatePackageUpgradeSwapFeeLine(saleLine, false);
                }

                saleLine.employeeId = (saleLine.employee.id) ? saleLine.employee.id : Guid.empty.toString();
                saleLine.employee2Criteria = { showEmployeesOnly: true, allowSales: true, excludeIdList: [saleLine.employeeId] }
            }

            if (fromTypeAhead && saleLine.secondEmployee) {
                if (isSecondEmployee && this.isEmployeeHouseEmployee(saleLine.secondEmployee)) {
                    this.modalService.confirmHandler(this.$translate.instant("MESSAGE_SPLIT_COMMISSION_WITH_HOUSE", { employee: this.HouseEmployee.displayName }))
                        .then((response: boolean) => {
                            if (response) {
                                this.postEmployeeChanged(saleLine, isSecondEmployee);
                                if (saleLine.employeeSplitCommission == 1 && saleLine.secondEmployeeSplitCommission == 1) {
                                    saleLine.secondEmployeeSplitCommission = 0;
                                    saleLine.employeeSplitCommission = 0;
                                }
                            } else {
                                if (isSecondEmployee) {
                                    this.removeSecondEmployee(saleLine);
                                } else {
                                    saleLine.employee = null;
                                    saleLine.employeeId = null;
                                }
                            }
                        });
                } else {
                    this.postEmployeeChanged(saleLine, isSecondEmployee);
                }
            }
        }

        saleLineHasLinkedIds(saleLine: Model.TransactionEditorSaleLine) {
            return saleLine.linkedSaleLineIds && saleLine.linkedSaleLineIds.length > 0;
        }

        updatePackageUpgradeSwapFeeLine(saleLine: Model.TransactionEditorSaleLine, isClient: boolean) {
            let feeSaleLine = this.getLinkedSwapFeeSaleLine(saleLine);
            if (feeSaleLine === undefined) return;

            let message = this.$translate.instant(isClient ? "MESSAGE_UPDATE_CLIENT_FOR_SWAP_FEE" : "MESSAGE_UPDATE_EMPLOYEE_FOR_SWAP_FEE");

            this.modalService.yellowConfirm(message, null, null, undefined, true)
                .then((response) => {
                    if (response) {
                        this.updateSwapFeeClientOrEmployee(feeSaleLine, saleLine, isClient);
                    } else {
                        this.updateSwapFeeClientOrEmployee(saleLine, feeSaleLine, isClient);
                    }
                });
        }

        getLinkedSwapFeeSaleLine(saleLine: Model.TransactionEditorSaleLine): Model.TransactionEditorSaleLine {
            let linkedSale = _(this.transactionResults.pages).flatten().find(sale => sale.id === saleLine.saleId);
            return linkedSale.detail.saleLines.find(saleLineCandidate =>
                    saleLineCandidate.saleType === Model.SalesTypeEnum.PackageServiceSwapFee &&
                    saleLineCandidate.id === saleLine.linkedSaleLineIds[0]);
        }

        updateSwapFeeClientOrEmployee(toSaleLine: Model.TransactionEditorSaleLine, fromSaleLine: Model.TransactionEditorSaleLine, isClient: boolean) {
            if (isClient) {
                toSaleLine.clientId = fromSaleLine.client.id;
                toSaleLine.clientType = fromSaleLine.clientType;
                toSaleLine.client = fromSaleLine.client || {
                    id: undefined,
                    clientType: fromSaleLine.clientType,
                    displayName: this.getAnonymousClientName(fromSaleLine.clientType)
                };
            } else {
                toSaleLine.employee = fromSaleLine.employee;
                toSaleLine.employeeId = (fromSaleLine.employee.id) ? fromSaleLine.employee.id : Guid.empty.toString();
            }
        }

        postEmployeeChanged(saleLine, isSecondEmployee) {
            saleLine.secondEmployeeId = saleLine.secondEmployee.id;
            saleLine.employeeCriteria = { showEmployeesOnly: true, allowSales: true, excludeIdList: [saleLine.secondEmployeeId] }
        }

        removeSecondEmployee(saleLine: Model.TransactionEditorSaleLine) {
            (<any>saleLine).secondEmployee = null;
            (<any>saleLine).secondEmployeeId = null;
            (<any>saleLine).secondEmployeeSplitCommission = null;
        }

        paymentTypeChanged(transItem, payment: Model.SalePayment) {
            // newly selected payment is Check or previous payment is Check
            if (payment.paymentType.paymentCategory === Meevo.Model.PaymentCategoryEnum.Check || payment.paymentCategory === Meevo.Model.PaymentCategoryEnum.Check) {
                let newPayment;
                if (payment.paymentType.paymentCategory === Meevo.Model.PaymentCategoryEnum.Check) {
                    newPayment = {
                        __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentCheck, Millennium.Meevo.Register.Contracts.Model",
                        checkNumber: ""
                    };
                }
                else {
                    newPayment = {};
                }

                newPayment.paymentTypeId = payment.paymentType.id;
                newPayment.paymentCategory = payment.paymentType.paymentCategory;
                newPayment.paymentTypeDisplayName = payment.paymentType.displayName;
                newPayment.amount = payment.amount;
                newPayment.updated = true;
                newPayment.id = payment.id;
                newPayment.paymentType = payment.paymentType;

                let paymentIndex = _.findIndex(transItem.detail.paymentLines, (item: Model.SalePayment) => item.id == payment.id);
                if (paymentIndex >= 0) {
                    this.modifiedPaymentLines[paymentIndex] = newPayment;
                }
            }

            payment.paymentCategory = payment.paymentType.paymentCategory;
            payment.paymentTypeId = payment.paymentType.id;
            payment.paymentTypeDisplayName = payment.paymentType.displayName;
            payment.updated = true;
        }

        isSaleLineHidden(saleLine: Model.SaleLine): boolean {
            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.PackageMerge:
                case Model.SalesTypeEnum.PackageSplit:
                case Model.SalesTypeEnum.AssociatedClient:
                    return true;
                case Model.SalesTypeEnum.PaymentSurcharge:
                    return !saleLine.isRefund;
            }

            return false;
        }

        startSplitCommission(saleLine: Model.TransactionEditorSaleLine) {
            if (this.isEmployeeHouseEmployee(saleLine.employee)) {
                this.modalService.alert(this.$translate.instant("MESSAGE_NO_SPLIT_COMMISSION_HOUSE"));
            } else {
                this.postStartSplitCommission(saleLine);
            }
        }

        postStartSplitCommission(saleLine: Model.TransactionEditorSaleLine) {
            saleLine.secondEmployee = {};
            saleLine.secondEmployeeSplitCommission = 0;
            saleLine.employee2Criteria = { showEmployeesOnly: true, allowSales: true, excludeIdList: [saleLine.employeeId] };
        }

        removeSplitCommission(saleLine: Model.TransactionEditorSaleLine) {
            saleLine.secondEmployee = null;
            saleLine.secondEmployeeId = null;
            saleLine.employeeCriteria = { showEmployeesOnly: true, allowSales: true }
            saleLine.secondEmployeeSplitCommission = null;
            saleLine.employeeSplitCommission = 1;
        }

        splitCommission1Changed(saleLine: Model.SaleLine) {
            saleLine.secondEmployeeSplitCommission = 1 - Number(saleLine.employeeSplitCommission);
        }

        splitCommission2Changed(saleLine: Model.SaleLine) {
            saleLine.employeeSplitCommission = 1 - Number(saleLine.secondEmployeeSplitCommission);
        }

        isSplitCommissionFullVisible(saleLine: Model.SaleLine): boolean {
            return saleLine &&
                saleLine.secondEmployeeId &&
                saleLine.secondEmployeeId != this.HouseEmployee.id &&
                !this.isSplitCommissionFullSet(saleLine);
        }

        isSplitCommissionFullSet(saleLine: Model.SaleLine): boolean {
            return saleLine &&
                saleLine.employeeSplitCommission === 1 &&
                saleLine.secondEmployeeSplitCommission === 1;
        }

        applySplitCommissionFull(saleLine: Model.SaleLine) {
            saleLine.secondEmployeeSplitCommission = 1;
            saleLine.employeeSplitCommission = 1;
        }

        itemHasSplitCommission(transItem) {
            if (!transItem.detail) {
                return;
            }

            return _(transItem.detail.saleLines).find((saleLine) => saleLine.secondEmployee != null || saleLine.secondEmployeeId != null);
        }

        isSplitCommissionValid(transItem): boolean {
            let returnValue = true;
            transItem.detail.saleLines.forEach(saleLine => {
                //if both commissions are 0, or it did not resolve to sum >= 1, we want to stop saving. Can't be same Employee. Can't have House as Prime with Second as an Employee
                if (this.saleLineHasSplitCommission(saleLine) &&
                    (saleLine.employeeSplitCommission + saleLine.secondEmployeeSplitCommission != 1 &&
                    (saleLine.employeeSplitCommission != 1 || saleLine.secondEmployeeSplitCommission != 1)) ||
                    saleLine.employeeId == saleLine.secondEmployeeId || (this.isEmployeeHouseEmployee(saleLine.employee) && saleLine.secondEmployee != null)
                ) {
                    returnValue = false;
                }
            });
            return returnValue;
        }

        itemCanHaveTeacher(transItem) {
            if (!transItem.detail) {
                return;
            }
            return _(transItem.detail.saleLines).find((saleLine) => this.saleLineCanHaveTeacher(saleLine));
        }

        saleLineCanHaveTeacher(saleLine) {
            return (saleLine.saleType === Model.SalesTypeEnum.Service || saleLine.saleType === Model.SalesTypeEnum.Product) &&
                ((saleLine.employee && saleLine.employee.employeeEntityType == Model.EmployeeEntityTypeEnum.Student) ||
                    (saleLine.secondEmployee && saleLine.secondEmployee.employeeEntityType == Model.EmployeeEntityTypeEnum.Student));
        }

        isDepositVisible(saleLine: Model.SaleLine): boolean {
            return saleLine &&
                !saleLine.isRefund &&
                saleLine.saleType === Model.SalesTypeEnum.Service &&
                saleLine.item &&
                !!(<Model.ServiceSaleLineItem>saleLine.item).depositAmount;
        }

        itemHasGiftCardSale(transItem) {
            if (!transItem.detail) {
                return;
            }

            return _(transItem.detail.saleLines).find((saleLine) => this.isGiftCardSaleLine(saleLine));
        }

        giftCardPurchasedForClientChanged(giftCardItem) {
            if (giftCardItem && giftCardItem.purchasedForClient) {
                giftCardItem.purchasedForClientId = giftCardItem.purchasedForClient.id;
            }
        }

        clientPackagePurchasedForChanged(packageItem) {
            if (packageItem && packageItem.clientPackage && packageItem.clientPackage.client) {
                packageItem.clientPackage.clientId = packageItem.clientPackage.client.id;
            }
        }

        isGiftCardSaleLine(saleLine, includeBulk: boolean = false) {
            return saleLine.saleType == Model.SalesTypeEnum.GiftCard || saleLine.saleType == Model.SalesTypeEnum.PromoGiftCard
                || saleLine.saleType == Model.SalesTypeEnum.ReloadGiftCard ||
                (includeBulk && saleLine.saleType === Model.SalesTypeEnum.BulkGiftCard);
        }

        isGiftCardSaleLinePurchasedForEditable(saleLine) {
            return this.isEditingPermanentlyEditableFields && saleLine.saleType !== Model.SalesTypeEnum.BulkGiftCard && saleLine.saleType !== Model.SalesTypeEnum.ReloadGiftCard;
        }

        isClientEditable(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType !== Meevo.Model.SalesTypeEnum.PackageServiceSwapFee;
        }

        isPaymentPlanPaymentSaleLine(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPayment ||
                saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPaymentEFT;
        }

        isPaymentPlanSaleLine(saleLine: Model.SaleLine): boolean {
            return this.isPaymentPlanPaymentSaleLine(saleLine) ||
                saleLine.saleType === Model.SalesTypeEnum.PaymentPlanReduction;
        }

        saleLineHasSplitCommission(saleLine: Model.SaleLine): boolean {
            // secondEmployee not null, secondEmployeeId null when adding new second employee.  Typeahead is empty
            // secondEmployee null, secondEmployeeId not null when clearing typeahead
            return !!(saleLine.secondEmployee || saleLine.secondEmployeeId);
        }

        isEmployeeVisible(saleLine: Meevo.Model.SaleLine): boolean {
            switch (saleLine.saleType) {
                case Meevo.Model.SalesTypeEnum.PaymentSurcharge:
                    return false;
            }

            return true;
        }

        isEmployeeEditable(saleLine: Meevo.Model.SaleLine): boolean {
            if (!!saleLine.externalTipTransactionId) {
                return false;
            }

            switch (saleLine.saleType) {
                case Meevo.Model.SalesTypeEnum.TicketCharge:
                case Meevo.Model.SalesTypeEnum.DepositCredit:
                case Meevo.Model.SalesTypeEnum.ClientAccountCredit:
                case Meevo.Model.SalesTypeEnum.ClientAccountPayment:
                case Meevo.Model.SalesTypeEnum.PackageServiceSwapFee:
                case Meevo.Model.SalesTypeEnum.PaymentSurcharge:
                    return false;
            }

            return true;
        }

        updateTip(tipLines: any[] = null, tipPercentage: number = null, tipAmount: number = null) {
            if (tipLines != null) {
                this.sale.tipLines = angular.copy(tipLines);
                this.sale.tipPercentage = tipPercentage;
                this.sale.tipAmount = tipAmount;
            }
            let currentTip = 0;
            let currentTipRefund = 0;
            for (const tipLine of this.sale.tipLines) {
                if (tipLine.isRefund) {
                    currentTipRefund += tipLine.amount;
                } else {                     
                    currentTip += tipLine.amount;
                }                
            }
            this.sale.total = this.normalizeDecimalPlaces(this.sale.total - this.sale.tip + currentTip + currentTipRefund);
            this.sale.tip = this.normalizeDecimalPlaces(currentTip);
            this.sale.tipRefund = this.normalizeDecimalPlaces(currentTipRefund);
            this.recalculateChangeDue();
        }

        normalizeNumber(value: number): number {
            return this.roundingService.normalizeNumber(value);
        }

        normalizeDecimalPlaces(value: number) {
            return this.roundingService.normalizeDecimalPlaces(value);
        }

        subtractNormalizedNumbers(value1: number, value2: number): number {
            return this.roundingService.subtractNormalizedNumbers(value1, value2);
        }

        addNormalizedNumbers(value1: number, value2: number): number {
            return this.roundingService.addNormalizedNumbers(value1, value2);
        }

        performOperationOnNormalizedNumbers(value1: number, value2: number, op: Function): number {
            return this.roundingService.performOperationOnNormalizedNumbers(value1, value2, op);
        }

        isCancellationFee(saleLine: Model.SaleLine): boolean {
            return _(saleLine.discountLines).any(discountLine => discountLine.saleLineDiscountType === Model.SaleLineDiscountTypeEnum.CancellationFee);
        }

        isNoShowFee(saleLine: Model.SaleLine): boolean {
            return _(saleLine.discountLines).any(discountLine => discountLine.saleLineDiscountType === Model.SaleLineDiscountTypeEnum.NoShowFee);
        }

        isPackageRefund(saleLine: Model.SaleLine): boolean {
            return saleLine.isRefund && (saleLine.saleType === Model.SalesTypeEnum.Package || saleLine.saleType === Model.SalesTypeEnum.PackageRefund);
        }

        isPackage(saleLine: Model.SaleLine): boolean {
            return (saleLine.saleType === Model.SalesTypeEnum.Package);
        }

        isRefundedIntoPackage(saleLine: Model.SaleLine) {
            return saleLine.saleType === Model.SalesTypeEnum.PackageRefund;
        }

        isPackagePurchasedForVisible(saleLine: Model.SaleLine) {
            return this.isPackage(saleLine) || this.isRefundedIntoPackage(saleLine);
        }

        getPackageServices(saleLine) {
            if (saleLine.saleType !== Model.SalesTypeEnum.Package || !saleLine.item.clientPackage) {
                return null;
            }
            if (!saleLine.packageServices) {
                saleLine.packageServices = _.groupBy(saleLine.item.clientPackage.refundedPackageServices, "serviceId");
            }
            return saleLine.packageServices;
        }

        getPackageProducts(saleLine) {
            if (saleLine.saleType !== Model.SalesTypeEnum.Package || !saleLine.item.clientPackage) {
                return null;
            }
            if (!saleLine.packageProducts) {
                saleLine.packageProducts = _.groupBy(saleLine.item.clientPackage.refundedPackageProducts, "productVariantId");
            }
            return saleLine.packageProducts;
        }

        getPackageItems(saleLine) {
            if (saleLine.saleType !== Model.SalesTypeEnum.Package || !saleLine.item.clientPackage) {
                return null;
            }
            if (!saleLine.packageItems) {
                saleLine.packageItems = _.groupBy(saleLine.item.clientPackage.refundedPackageItems, 'id');
            }
            return saleLine.packageItems;
        }

        getCancellationFee(saleLine: Model.SaleLine) {
            let cancellationFeeDiscount = _.findWhere(saleLine.discountLines, { saleLineDiscountType: Model.SaleLineDiscountTypeEnum.CancellationFee });
            return (cancellationFeeDiscount.type === Model.DiscountTypeEnum.SpecialPrice)
                ? cancellationFeeDiscount.discountValue
                : this.normalizeDecimalPlaces(saleLine.basePrice - (cancellationFeeDiscount.discountValue * saleLine.basePrice));
        }

        getNoShowFee(saleLine: Model.SaleLine) {
            let noShowFeeDiscount = _.findWhere(saleLine.discountLines, { saleLineDiscountType: Model.SaleLineDiscountTypeEnum.NoShowFee });
            return (noShowFeeDiscount.type === Model.DiscountTypeEnum.SpecialPrice)
                ? noShowFeeDiscount.discountValue
                : this.normalizeDecimalPlaces(saleLine.basePrice - (noShowFeeDiscount.discountValue * saleLine.basePrice));
        }

        checkForItemDetail(item) {
            if (!item.detail) {
                this.getTransactionDetail(item);
            }
        }

        hasPurchasedItems(item): boolean {
            return (item.detail && item.detail.hasPurchasedItems != undefined) ? item.detail.hasPurchasedItems : false;
        }

        checkForRefundableItems(transItem) {
            this.canRefundTransactionFlags[transItem.transactionId] = false;
            return this.dataService
                .customMethodData(`api/sale/${transItem.transactionId}/saleLine/list`, "POST", { criteria: { isRefundEligible: true } })
                .then((response) => {
                    if (response && response.data) {
                        let sale: Model.Sale = response.data;
                        this.canRefundTransactionFlags[transItem.transactionId] = (sale.saleLines && sale.saleLines.length > 0) || (sale.tipLines && sale.tipLines.length > 0);
                    }
                });
        }

        hasRefundableItems(transItem): boolean {
            return this.canRefundTransactionFlags[transItem.transactionId] && this.canRefund;
        }

        routeToReport() {
            if (this.criteria.includeOnHold) {
                this.modalService.alert("MESSAGE_TRANSACTION_EDITOR_REPORT_NOT_VALID");
            }
            else {
                let data = this.criteria;
                data["clients"] = this.clients;
                data["employee"] = this.employee;
                data["createdBy"] = this.user;
                data["drawer"] = this.drawer;
                this.reportRouterService.routeToReport(this.meevoSecurityKeys.REPORTS_REGISTERSALES_MR100, data);
            }
        }

        getTotalTipFromDevice(): number {
            if (!this.creditCardProcessingEnabled) {
                return null;
            }

            let total = 0;

            this.sale.paymentLines
                .forEach((paymentLine: Model.SalePayment) => {
                    if (paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit) {
                        total += paymentLine.amount;
                    }
                });

            let subTotal = this.sale.subTotal + this.sale.tax + this.sale.totalPrepaidTipRedeemed;

            return Math.max(0, this.normalizeDecimalPlaces(total - subTotal));
        }

        getTotalTipPercentageFromDevice() {
            return null;
        }

        getServiceTotalFromDevice() {
            return null;
        }

        getTotalTipFromPrepaid(): number {
            let total = 0;

            this.sale.saleLines
                .forEach((saleLine: Model.SaleLine) => {
                    total += saleLine.prepaidTipRedeemed;
                });

            return Math.max(0, this.normalizeDecimalPlaces(total));
        }

        startDateChanged() {
            if (this.criteria.startDateTime.valueOf() > this.criteria.endDateTime.valueOf()) {
                this.criteria.endDateTime = moment(this.criteria.startDateTime).endOf("day").toDate();
            }
        }

        endDateChanged() {
            if (this.criteria.startDateTime.valueOf() > this.criteria.endDateTime.valueOf()) {
                this.criteria.startDateTime = moment(this.criteria.endDateTime).startOf("day").toDate();
            }
        }

        isLocale(locale): boolean {
            return this.appSettings.APP_COUNTRYID.toLowerCase() == locale.toLowerCase();
        }

        getPaymentTypeDisplayName(paymentType: Model.PaymentTypeListItem): string {
            if (!paymentType) {
                return null;
            }

            const key = 'LABEL_PAYMENT_TYPE_' + paymentType.paymentCategory;
            const lookup = this.$translate.instant(key);
            if (lookup !== key) {
                return lookup;
            }

            switch (paymentType.paymentCategory) {
                case Model.PaymentCategoryEnum.PointsRewards:
                    return this.$translate.instant("LABEL_POINTS");
            }

            return paymentType.displayName;
        }

        getPaymentDisplayName(payment: Model.SalePayment): string {
            if (!payment) {
                return null;
            }

            var paymentType = this.getPaymentTypeDisplayName(payment.paymentType);
            var paymentDetail: string;

            switch (payment.paymentType.paymentCategory) {
                case Model.PaymentCategoryEnum.GiftCard:
                    paymentDetail = (<Model.SaleGiftCardPayment>payment).giftCardNumber;
                    break;
                case Model.PaymentCategoryEnum.ClientAccount:
                    paymentDetail = (<Model.SaleClientAccountPayment>payment).clientDisplayName;
                    break;
                case Model.PaymentCategoryEnum.CreditDebit:
                    const creditCardPayment = (<Model.SaleCreditCardPayment>payment).paymentRequest;
                    paymentDetail = creditCardPayment ? creditCardPayment.creditCardNumber : '';
                    break;
                case Model.PaymentCategoryEnum.PointsRewards:
                    paymentDetail = '- ' + (<Model.SaleClientPointPayment>payment).clientDisplayName;
                    break;
            }

            paymentDetail = paymentDetail ? ` ${paymentDetail}` : '';

            return `${paymentType}${paymentDetail}`;
        }

        getTaxListText(sale: Model.Sale) {
            if (!sale || !sale.saleLines || sale.saleLines.length === 0) {
                return "";
            }

            const taxList = _(sale.taxes).filter(tax => tax.isIncludedInPrice);
            if (taxList.length === 0) {
                return "";
            }

            const taxNameList = _(_.mapObject(_(taxList).groupBy((tax) => tax.taxTypeId), (values, taxTypeId) => values[0].taxTypeDisplayName)).values();
            const includingTax = this.$translate.instant("LABEL_INCLUDING_TAX");

            return ` (${includingTax} ${taxNameList.join(', ')})`;
        }

        getTaxListNotIncludedInPrice(sale: Model.Sale) {
            if (!sale || !sale.taxes) {
                return null;
            }

            return _(sale.taxes).filter(tax => !tax.isIncludedInPrice);
        }

        checkForRefundAndVoidActions(item, fn, event) {
            event.stopPropagation();
            return this.$q.all([this.checkForRefundableItems(item), this.canVoidAsync(item)]).then((responses) => {
                if (!this.canRefundTransactionFlags[item.transactionId] && !item.canVoid) {
                    return this.modalService.alert("MESSAGE_TRANSACTION_CANNOT_BE_REFUNDED_NOR_VOIDED");
                }
                else {
                    fn(event);
                }
            });
        }

        hasDiscountAffectingCommissions(saleLine: Model.SaleLine): boolean {
            return (saleLine.discountLines
                && _.find(saleLine.discountLines, (discount) => {
                    return (discount.saleLineDiscountType !== Model.SaleLineDiscountTypeEnum.ItemOnSale
                        && discount.saleLineDiscountType !== Model.SaleLineDiscountTypeEnum.CancellationFee
                        && discount.saleLineDiscountType !== Model.SaleLineDiscountTypeEnum.MembershipBenefit
                        && !discount.isBuyItem);
                }) != null);
        }

        applyFullCommision(saleLine: Model.SaleLine) {
            saleLine.isFullCommissionApplicableManuallyChecked = true;
        }

        getPackageNumberDisplayName(saleLine: Model.SaleLine): string {
            if (!saleLine || !saleLine.redeemedPackages || saleLine.redeemedPackages.length == 0) {
                return "";
            }

            const clientPackageNumber = saleLine.redeemedPackages[0].clientPackageNumber;

            return this.$translate.instant("LABEL_PKG_REDEEMED") + ": " + clientPackageNumber;
        }

        saleLineItemEditable(saleLine: Model.SaleLine): boolean {
            let isTransactionToday = this.isTransactionToday(saleLine);
            return this.isEditing && !saleLine.isRefund &&
                ((saleLine.saleType === Model.SalesTypeEnum.Service && !this.hasRedeemedPackages(saleLine) && !(<Register.ServiceSaleLineItem>saleLine.item).isPromoGiftCardUsed)
                    || (saleLine.saleType === Model.SalesTypeEnum.Product && isTransactionToday));
        }

        hasRedeemedPackages(saleLine: Model.SaleLine): boolean {
            return saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0;
        }

        isTransactionToday(saleLine: Model.SaleLine): boolean {
            return moment().diff(<any>saleLine.saleDate, 'days') === 0;
        }

        get filterWildcardType(): any {
            return Model.FilterWildcardType;
        }

        get salesTypeEnum(): any {
            return Model.SalesTypeEnum;
        }

        productCriteria = {
            includeBundles: false,
            includeProducts: true,
            variantObjectState: [Model.ObjectStateEnum.Active, Model.ObjectStateEnum.Inactive],
            wildcardType: Model.FilterWildcardType.Contains
        }

        getProductCriteria(saleLine) {
            saleLine.productCriteria.explicitProductInventoryTypes = [saleLine.item.productInventoryType, Model.ProductInventoryTypeEnum.RetailOrShopSupply];
            return saleLine.productCriteria;
        }

        populateTransactionNotes(transItem) {
            let sale = transItem.detail;
            if (sale && sale.saleNotes && sale.saleNotes.length > 0) {
                sale.transactionNote = _(sale.saleNotes).find((note) => note.noteType === Model.SaleNoteTypeEnum.Transaction || note.noteType === Model.SaleNoteTypeEnum.Discount);
                sale.refundNote = _(sale.saleNotes).find((note) => note.noteType === Model.SaleNoteTypeEnum.Refund);
            }
        }

        isDiscountNote(note): boolean {
            return (note.noteType === Model.SaleNoteTypeEnum.Discount);
        }

        displayProductInventoryType(saleLine) {
            return this.saleLineItemEditable(saleLine) && saleLine.saleType === Model.SalesTypeEnum.Product;
        }

        inventoryTypeChanged(saleLine) {
            // same inventory type chosen
            if (!saleLine.product || saleLine.item.tempProductInventoryType === saleLine.item.productInventoryType) {
                return;
            }
            if (saleLine.item.baseProductInventoryType !== Model.ProductInventoryTypeEnum.RetailOrShopSupply) {
                this.modalService.okCancelHandler("MESSAGE_CHANGE_INVENTORY_TYPE_FILTER").then(yesResponse => {
                    if (yesResponse) {
                        saleLine.product = undefined;
                        saleLine.item.productInventoryType = saleLine.item.tempProductInventoryType;
                    }
                    else {
                        // revert inventory type back
                        saleLine.item.tempProductInventoryType = saleLine.item.productInventoryType;
                    }
                })
                return;
            }
            saleLine.item.productInventoryType = saleLine.item.tempProductInventoryType;
        }

        updateFieldEditSecurityKey(securityKey: string): ng.IPromise<string> {
            return this.securityService.checkSecurityItem(securityKey).then(securityItem => {
                return securityItem.securityAccess === Model.SecurityAccessEnum.Hide
                    ? this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR + Components.Common.SecurityParts.KEY_PART_READ
                    : securityKey;
            })
        }

        isFieldDisabledForEdit(securityKey: string): boolean {
            return securityKey === this.meevoSecurityKeys.REGISTER_TRANSACTIONEDITOR + Components.Common.SecurityParts.KEY_PART_READ;
        }

        isPaymentDisabledForEdit(payment: any) {
            return !!payment.surcharge;
        }

        isPriceDiscounted(saleLine: Model.SaleLine): boolean {
            return this.registerDiscountService.isPriceDiscounted(this, saleLine);
        }

        groupSaleLinesByClient(transItem: any) {
            var saleLines = _.sortBy(transItem.detail.saleLines, (saleLine: any) => saleLine.id);
            var sortedSaleLines = [];

            while (saleLines.length > 0) {
                var firstSaleLineClientId = saleLines[0].clientId || saleLines[0].clientType;
                var matchingLines = saleLines.filter(line =>
                    firstSaleLineClientId === line.clientId ||
                    firstSaleLineClientId === line.clientType);
                sortedSaleLines.push(matchingLines);
                saleLines = saleLines.filter(saleLine => matchingLines.indexOf(saleLine) === -1);
            };

            transItem.detail.saleLines = _(sortedSaleLines).flatten();
        }

        openActivityLog(transItem: any) {
            const continueOpenActivityLog = (transItem) => {

                const effectiveTransactionDate = transItem.detail.dateUpdated ?
                    transItem.detail.dateUpdated :
                    transItem.transactionDateTime;

                const filterParams: any = {
                    auditActivity: Plugins.ActivityLog.CategorySearchEnum.All,
                    client: null,
                    employee: null,
                    user: null,
                    filter: null,
                    keyword: null,
                    isGlobal: false,
                    maintenanceMode: false,
                    purpose: null,
                    wildcardType: null,
                    startDate: moment(transItem.detail.dateCreated).add(-2, 'minutes').toDate(),
                    endDate: moment(effectiveTransactionDate).add(2, 'minutes').toDate(),
                    timeType: Plugins.ActivityLog.TimeTypesEnum.Custom,
                    postFilter: transItem.transactionId,
                    transactionId: transItem.detail.transactionId
                }

                const stateParams: any = {
                    filterParams: filterParams,
                    callbackState: this.appSettings.ROUTE_NAMES.transactionEditor
                }

                this.$rootScope.$broadcast(Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.activityLog,
                    stateParams: stateParams,
                    securityKey: Meevo.Components.Common.SecurityKeys.MANAGEMENT_ACTIVITYLOG + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                });
            }

            if (transItem.detail) {
                continueOpenActivityLog(transItem);
                return;
            }

            this.getTransactionDetail(transItem).then(() => continueOpenActivityLog(transItem));
        }

        getProductReturnToShelfIndicator(saleLine: Model.SaleLine) {
            if (saleLine.saleType == Model.SalesTypeEnum.Product && saleLine.isRefund) {
                let productSaleItem = saleLine.item as Model.ProductSaleLineItem;
                let retVal = (productSaleItem.isResell ? "LABEL_PRODUCT_RETURNED_TO_SHELF" : "LABEL_PRODUCT_NOT_RETURNED_TO_SHELF");
                return this.$translate.instant(retVal);
            }
        }

        isItemBold(saleLine: Model.SaleLine): boolean {
            return (saleLine.saleType === Model.SalesTypeEnum.Product && saleLine.isRefund);
        }

        isGiftCardPurchasedForEditable(saleLine: Model.SaleLine): boolean {
            return (this.isEditingPermanentlyEditableFields && saleLine.saleType !== Model.SalesTypeEnum.ReloadGiftCard);
        }

        showDepositChargeInsufficientBalance(paymentLine: Model.SalePayment): boolean {
            return paymentLine.paymentType.paymentSubCategory === Model.PaymentSubCategoryEnum.DepositCharge &&
                paymentLine.amount === 0;
        }

        showDepositCreditInsufficientBalance(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.DepositCredit &&
                saleLine.isRefund && saleLine.finalPrice === 0;
        }

        showGiftReceiptPreview(item): ng.IPromise<any> {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/giftReceiptModal.template.html",
                controller: "meevo.plugins.register.GiftReceiptModal",
                controllerAs: "vm",
                bindToController: true,
                multiple: true,
                locals: {
                    transactionId: item.transactionId
                }
            }

            return this.modalService.showCustom(options).then((excludeSaleLineList) => {
                return excludeSaleLineList;
            });
        }

        isReturnToShelfEditable(saleLine: Model.SaleLine): boolean {
            return this.isEditing && saleLine.isRefund && saleLine.saleType == Model.SalesTypeEnum.Product && this.isTransactionToday(saleLine);
        }

        goToGiftCardBalanceModal(giftCardId: string) {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/giftCardBalance/giftCardBalanceModal.template.html',
                controller: 'meevo.plugins.giftCardBalance.GiftCardBalanceModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    giftCardId: giftCardId,
                    giftCardNumber: undefined
                },
            };

            this.modalService.showCustom(modalOptions);
        }

        setNoteType(transactionNote, isDiscountType) {
            if (!transactionNote) {
                return;
            }

            transactionNote.noteType = isDiscountType ?
                this.discountNoteType :
                Model.SaleNoteTypeEnum.Transaction;
        }

        filterItemTypeChanged() {
            this.criteria.requiredSalesType = this.selectedFilterItemType ? this.selectedFilterItemType.itemType : null;
            this.criteria.requiredItemId = this.selectedFilterItem = null;
        }

        filterItemChanged() {
            this.criteria.requiredItemId = this.selectedFilterItem ? this.selectedFilterItem.id : null;
        }

        filterSurchargeablePaymentTypes(transItem: any) {
            if (!this.isSurchargeModuleEnabled || !transItem.drawerId) {
                return;
            }
            this.getSurchargeablePaymentTypesByDrawerId(transItem.drawerId).then(surchargeablePaymentTypeIds => {
                if (surchargeablePaymentTypeIds.length < 1) {
                    return;
                }
                for (let paymentLine of transItem.detail.paymentLines) {
                    paymentLine.paymentTypeList = paymentLine.paymentTypeList
                        .filter(paymentType => paymentLine.paymentTypeId === paymentType.id ||
                            !_(surchargeablePaymentTypeIds).contains(paymentType.id));
                }
            });
        }

        getSurchargeablePaymentTypesByDrawerId(drawerId) {
            const getMerchantAccountId = this.merchantAccountIdByDrawerId.has(drawerId) ?
                this.$q.resolve(this.merchantAccountIdByDrawerId.get(drawerId)) :
                this.dataService.getItem<Model.Drawer>(this.appSettings.API_ENDPOINTS.drawer, drawerId).then((res: Model.Drawer) => {
                    const merchantAccountId = res.merchantAccountId ? res.merchantAccountId.toString() : undefined;
                    this.merchantAccountIdByDrawerId.set(drawerId, merchantAccountId)
                    return merchantAccountId;
                });

            return getMerchantAccountId
                .then(merchantAccountId => this.getSurchargeablePaymentTypesByMerchantAccountId(merchantAccountId));
        }

        getSurchargeablePaymentTypesByMerchantAccountId(merchantAccountId) {
            if (!merchantAccountId) {
                return this.$q.resolve([]);
            }
            const paymentTypeIds = this.surchargePaymentTypesByMerchantAccountId.get(merchantAccountId);
            if (paymentTypeIds) {
                return this.$q.resolve(paymentTypeIds);
            }

            const url = this.appSettings.API_ROOT + '/' + this.appSettings.API_ENDPOINTS.merchantAccount + '/' + merchantAccountId + '/surcharges';
            return this.dataService.customMethodData(url, 'GET', null).then(res => {
                const surcharges = res.data;
                const paymentTypeIds = !surcharges || !surcharges.isSurchargeEnabled ? [] :
                    surcharges.surcharges
                        .filter(surcharge => surcharge.paymentCategory !== Model.PaymentCategoryEnum.CreditDebit &&
                            surcharge.isEnabled)
                        .map(surcharge => surcharge.paymentTypeId);
                this.surchargePaymentTypesByMerchantAccountId.set(merchantAccountId, paymentTypeIds);
                return paymentTypeIds;
            });
        }

        getVariantDisplayName(variant: Meevo.Model.IProductUsageVariant): string {
            return `${variant.productSku}: ${variant.productDisplayName}${(variant.variantDisplayName ? ' - ' + variant.variantDisplayName : '')}`;
        }

        getUnitOfMeasure(unitOfMeasure: Meevo.Model.UnitEnum, productUsageAmountType: Meevo.Model.ProductUsageAmountTypeEnum): string {
            switch (productUsageAmountType) {
                case Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount:
                    switch (unitOfMeasure) {
                        case Meevo.Model.UnitEnum.FluidOunce:
                            return this.$translate.instant("LABEL_FLUID_OUNCE_ABBR");
                        default:
                            return this.$translate.instant("ENUM_LABEL_" + unitOfMeasure).substr(0, 2);
                    }
                case Meevo.Model.ProductUsageAmountTypeEnum.WholeProduct:
                    return this.$translate.instant("ENUM_LABEL_2365");
            }
        }

        hasPostServiceCareNotificationBeenSent(clientId, entityId) {
            const request = {
                communicationType: Model.CommunicationTypeEnum.PostServiceCare,
                communicationTypeUser: Model.CommunicationTypeUserEnum.Client,
                clientId: clientId,
                entityId: entityId,
                locationId: this.identityService.current().locationId,
                tenantId: this.identityService.current().tenantId
            }

            return this.dataService.customMethodData(`api/notification/hasNotificationSent`, "post", request);
        }

        isPostServiceCareNotificationEnabled(clientId, serviceId) {
            const request = {
                communicationType: Model.CommunicationTypeEnum.PostServiceCare,
                communicationTypeUser: Model.CommunicationTypeUserEnum.Client,
                clientId: clientId,
                serviceId: serviceId,
                locationId: this.identityService.current().locationId,
                tenantId: this.identityService.current().tenantId
            }

            return this.dataService.customMethodData(`api/notification/isNotificationEnabled`, "post", request);
        }
    }
}
